<template>
<div class="body_flow page">
    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Payment Error Toast -->
    <div v-if="paymentError" class="error-popup">
        <span>{{ errorMessage }}</span>
        <button class="error-popup-close" @click="paymentError = false">&times;</button>
    </div>

    <!-- Out of Stock Modal -->
    <div v-if="showOutOfStockModal" class="modal-overlay" @click="closeOutOfStockModal">
        <div class="modal-content out-of-stock-modal" @click.stop>
            <div class="intro-modal-body">
                <div class="intro-modal-heading">
                    <strong>{{ currentMedicationType === 'mounjaro' ? 'Mounjaro' : 'Ozempic' }} is temporarily out of stock as we await our next shipment. You may choose an alternative medication now, or we'll notify you as soon as it becomes available.</strong>
                </div>
                <button class="modal-close-button" @click="closeOutOfStockModal">Close</button>
            </div>
        </div>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="100vw" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el>3">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651" style="margin-bottom: 3px;"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"  v-if="active_el>3"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / (totalSteps+1)) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    <section class="section-fixed-controlnav hide-block">
        <div class="flow-ctrl-nav-wrap">
            <div class="ctrl-div">
                <div class="ctrl-div-flex">
                    <a href="#" class="continue-button w-button">Continue</a>
                </div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">
            <!-- Error Toast -->
            

            <div class="step_forminfo_div" v-if="active_el === 3">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Get Pre-Qualified in Minutes!</div>
                    <div class="text-block-1686">Get your medication in as little as 72 Hours.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="b6f9984d-e516-2288-ed34-749c02b56425" @submit.prevent="handleSubmit">
                            <div class="form-field-label">State*</div>
                            <div class="selectwrap">
                                <span class="select-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z">
                                        </path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C11.2919 1.25 10.6485 1.45282 9.95055 1.79224C9.27585 2.12035 8.49642 2.60409 7.52286 3.20832L5.45628 4.4909C4.53509 5.06261 3.79744 5.5204 3.2289 5.95581C2.64015 6.40669 2.18795 6.86589 1.86131 7.46263C1.53535 8.05812 1.38857 8.69174 1.31819 9.4407C1.24999 10.1665 1.24999 11.0541 1.25 12.1672V13.7799C1.24999 15.6837 1.24998 17.1866 1.4027 18.3616C1.55937 19.567 1.88856 20.5401 2.63236 21.3094C3.37958 22.0824 4.33046 22.4277 5.50761 22.5914C6.64849 22.75 8.10556 22.75 9.94185 22.75H14.0581C15.8944 22.75 17.3515 22.75 18.4924 22.5914C19.6695 22.4277 20.6204 22.0824 21.3676 21.3094C22.1114 20.5401 22.4406 19.567 22.5973 18.3616C22.75 17.1866 22.75 15.6838 22.75 13.7799V12.1672C22.75 11.0541 22.75 10.1665 22.6818 9.4407C22.6114 8.69174 22.4646 8.05812 22.1387 7.46263C21.8121 6.86589 21.3599 6.40669 20.7711 5.95581C20.2026 5.5204 19.4649 5.06262 18.5437 4.49091L16.4771 3.20831C15.5036 2.60409 14.7241 2.12034 14.0494 1.79224C13.3515 1.45282 12.7081 1.25 12 1.25ZM8.27953 4.50412C9.29529 3.87371 10.0095 3.43153 10.6065 3.1412C11.1882 2.85833 11.6002 2.75 12 2.75C12.3998 2.75 12.8118 2.85833 13.3935 3.14119C13.9905 3.43153 14.7047 3.87371 15.7205 4.50412L17.7205 5.74537C18.6813 6.34169 19.3559 6.76135 19.8591 7.1467C20.3487 7.52164 20.6303 7.83106 20.8229 8.18285C21.0162 8.53589 21.129 8.94865 21.1884 9.58104C21.2492 10.2286 21.25 11.0458 21.25 12.2039V13.725C21.25 15.6959 21.2485 17.1012 21.1098 18.1683C20.9736 19.2163 20.717 19.8244 20.2892 20.2669C19.8649 20.7058 19.2871 20.9664 18.2858 21.1057C17.2602 21.2483 15.9075 21.25 14 21.25H10C8.09247 21.25 6.73983 21.2483 5.71422 21.1057C4.71286 20.9664 4.13514 20.7058 3.71079 20.2669C3.28301 19.8244 3.02642 19.2163 2.89019 18.1683C2.75149 17.1012 2.75 15.6959 2.75 13.725V12.2039C2.75 11.0458 2.75076 10.2286 2.81161 9.58104C2.87103 8.94865 2.98385 8.53589 3.17709 8.18285C3.36965 7.83106 3.65133 7.52164 4.14092 7.1467C4.6441 6.76135 5.31869 6.34169 6.27953 5.74537L8.27953 4.50412Z">
                                        </path>
                                    </svg>
                                </span>
                                <select id="State-4" name="State-4" data-name="State 4" required="" class="checkout-flow-dropdown w-select" v-model="people.state" :class="{ 'field-error': fieldErrors.state }">
                                    <option value="" disabled selected>State...</option>
                                    <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                                </select>
                            </div>
                            <div class="form-field-label">Sex assigned at birth*</div>
                            <div class="selectwrap">
                                <span class="select-icon" aria-hidden="true"> <svg viewBox="0 0 16 16" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M3.47845 6.89783C3.47845 4.95347 5.05467 3.37725 6.99903 3.37725C8.94339 3.37725 10.5196 4.95347 10.5196 6.89783C10.5196 8.84217 8.94328 10.4184 6.99889 10.4184C5.05456 10.4184 3.47845 8.84222 3.47845 6.89783ZM6.99903 2.19631C4.40245 2.19631 2.29751 4.30125 2.29751 6.89783C2.29751 9.29443 4.09049 11.2721 6.40843 11.5626V12.5533H5.53082C5.20471 12.5533 4.94035 12.8177 4.94035 13.1438C4.94035 13.4699 5.20471 13.7342 5.53082 13.7342H6.40847L6.40858 15.1993C6.4086 15.5255 6.67299 15.7898 6.99909 15.7898C7.3252 15.7897 7.58954 15.5254 7.58952 15.1993L7.58941 13.7342H8.46728C8.79339 13.7342 9.05775 13.4699 9.05775 13.1438C9.05775 12.8177 8.79339 12.5533 8.46728 12.5533H7.58936V11.5626C9.90729 11.2721 11.7005 9.29447 11.7005 6.89783C11.7005 4.30125 9.59561 2.19631 6.99903 2.19631Z">
                                        </path>
                                        <path fill-rule="evenodd" d="M10.2124 0.745546C10.2124 0.532708 10.385 0.360168 10.5978 0.360168H13.167C13.3798 0.360168 13.5524 0.532708 13.5524 0.745546V3.31473C13.5524 3.52757 13.3798 3.70011 13.167 3.70011C12.9542 3.70011 12.7816 3.52757 12.7816 3.31473V1.67593L10.441 4.01652C11.1 4.7987 11.497 5.80878 11.497 6.91159C11.497 9.3947 9.48407 11.4077 7.00096 11.4077C4.51784 11.4077 2.50488 9.3947 2.50488 6.91159C2.50488 4.42848 4.51784 2.41552 7.00096 2.41552C8.10377 2.41552 9.11384 2.81257 9.89603 3.47151L12.2366 1.13092H10.5978C10.385 1.13092 10.2124 0.958384 10.2124 0.745546ZM7.00096 3.18627C4.94352 3.18627 3.27564 4.85415 3.27564 6.91159C3.27564 8.96902 4.94352 10.6369 7.00096 10.6369C9.05839 10.6369 10.7263 8.96902 10.7263 6.91159C10.7263 4.85415 9.05839 3.18627 7.00096 3.18627Z">
                                        </path>
                                    </svg>
                                </span>
                                <select id="field-2" name="field-2" data-name="Field 2" class="checkout-flow-dropdown w-select" v-model="people.gender" :class="{ 'field-error': fieldErrors.gender }">
                                    <option value="">Select an option...</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div> 
                            <div class="form-field-label">Date of birth*</div>
                            <div class="flex-input-div dob">
                                <div class="selectwrap">
                                    <span class="select-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0" aria-hidden="true" width="18" height="18">
                                            <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z">
                                            </path>
                                            <path d="M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z">
                                            </path>
                                            <path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z">
                                            </path>
                                            <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z">
                                            </path>
                                            <path d="M7 14C7.55229 14 8 13.5523 8 13C8 12.4477 7.55229 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14Z">
                                            </path>
                                            <path d="M7 18C7.55229 18 8 17.5523 8 17C8 16.4477 7.55229 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z">
                                            </path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.412 3.24999 9.14133 3.24999 9.94346 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V14.0564C22.75 15.8941 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0565 22.75H9.94359C8.10585 22.75 6.65018 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33855 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.86685 7.88123 2.8477 8.06061 2.83168 8.25H21.1683C21.1523 8.06061 21.1331 7.88124 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM2.75 12C2.75 11.146 2.75032 10.4027 2.76309 9.75H21.2369C21.2497 10.4027 21.25 11.146 21.25 12V14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25H10C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14V12Z">
                                            </path>
                                        </svg></span>
                                    <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-month" data-name="birth month" placeholder="MM" type="text" id="birth-month" required="" v-model="people.dob.mm" @input="handleDobInput($event, 'mm', 'birth-month', 'birth-day', 2)" :class="{ 'field-error': fieldErrors.dob_mm }">
                                </div>
                                <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-day" data-name="birth day" placeholder="DD" type="text" id="birth-day" required="" v-model="people.dob.dd" @input="handleDobInput($event, 'dd', 'birth-day', 'birth-year', 2)" :class="{ 'field-error': fieldErrors.dob_dd }">
                                <input class="checkout-flow-input thirds w-input" maxlength="4" pattern="[0-9]*" inputmode="numeric" name="birth-year" data-name="birth year" placeholder="YYYY" type="text" id="birth-year" required="" v-model="people.dob.yyyy" @input="handleDobInput($event, 'yyyy', 'birth-year', null, 4)" :class="{ 'field-error': fieldErrors.dob_yyyy }">
                            </div>
                        </form>
                        <div v-if="showErrorPopup" class="w-form-fail" style="display:block; margin-bottom: 15px; padding: 10px; text-align: center;">
                            <div>{{ errorMessage }}</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-2251">
                    <div class="text-block-1726">As seen on</div><img src="@/assets/images/Money_2021.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/Money_2021-p-500.webp 500w, @/assets/images/Money_2021-p-800.webp 800w, @/assets/images/Money_2021.webp 1000w" alt="" class="image-691">
                </div>
                <div class="flow-ctrls-div first">
                    <a href="#" class="continue-button step first w-button" @click.prevent="handleSubmit">Continue <span class="text-span-423">-&gt;</span></a>
                </div>
            </div>
            
            <div class="step_forminfo_div" v-if="active_el === 4">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Tell us about yourself</div>
                    <div class="text-block-1686">Helps confirm you qualify for program.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="975158ac-d4ca-de19-d5d4-b998f487811b" @submit.prevent="handleSubmit">
                            <div class="flex-input-div">
                                <div class="flow-form-half-div">
                                    <div class="form-field-label">Height* (Feet)</div>
                                    <input class="checkout-flow-input w-input" maxlength="1" name="height-feet" data-name="height feet" placeholder="eg. 5" pattern="[0-9]*" inputmode="numeric" type="text" id="height-feet" required="" v-model="people.height.foot" @input="handleHeightFeetInput" :class="{ 'field-error': fieldErrors.height_foot }">
                                </div>
                                <div class="flow-form-half-div">
                                    <div class="form-field-label">Height* (Inches)</div><input class="checkout-flow-input w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="height-inches" data-name="height inches" placeholder="eg. 3" type="text" id="height-inches" required="" v-model="people.height.inches" @input="handleInchesInput" :class="{ 'field-error': fieldErrors.height_inches }">
                                </div>
                            </div>
                            <div class="form-field-label">Weight* (Pounds)</div><input class="checkout-flow-input w-input" maxlength="3" pattern="[0-9]*" inputmode="numeric" name="Weight-pounds" data-name="Weight pounds" placeholder="eg. 200" type="text" id="Weight-pounds" required="" v-model="people.weight" @input="handleWeightInput" :class="{ 'field-error': fieldErrors.weight }">

                            <div class="bmi-div" v-if="bmi_calculated"><img src="@/assets/images/icon_info.svg" loading="lazy" alt="" class="image-686">
                                <div class="bmi-text">Your BMI Score is {{ bmi_calculated }}</div>
                            </div>
                            <div class="flow-ctrls-div first">
                                <a href="#" class="continue-button step first w-button" @click.prevent="handleSubmit">Continue <span class="text-span-423">-&gt;</span></a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="step_forminfo_div" v-if="active_el === 5">
                <!-- Loading Overlay -->
                <div v-if="isSubmitting" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#0c9ac4" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">Enter your details to save your progress</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" @submit.prevent="handleSubmit">
                            <div class="doc-bar-div"><img src="@/assets/images/Doctor_newself.webp" loading="lazy" sizes="(max-width: 767px) 100vw, 755.0000610351562px" srcset="@/assets/images/Doctor_newself-p-500.webp 500w, @/assets/images/Doctor_newself.webp 755w" alt="" class="image-687">
                                <div>
                                    <div class="text-block-1721">A doctor will prescribe your medication in less than 24 hours.</div>
                                </div>
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">First name*</div><input class="checkout-flow-input w-input" maxlength="256" name="first-name" data-name="first name" placeholder="Your first name" type="text" id="first-name" required="" v-model="people.first_name" :class="{ 'field-error': fieldErrors.first_name }">
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Last name*</div><input class="checkout-flow-input w-input" maxlength="256" name="last-name" data-name="last name" placeholder="Your last name" type="text" id="last-name" required="" v-model="people.last_name" :class="{ 'field-error': fieldErrors.last_name }">
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Email*</div><input class="checkout-flow-input w-input" maxlength="256" name="email" data-name="email" placeholder="Email address" type="email" id="email" required="" v-model="people.email" @blur="checkEmailOnBlur" :class="{ 'field-error': fieldErrors.email, 'email-error-highlight': emailCheckError }">
                                  </div>
                            <div class="flow-payment-div">
                                <div class="form-field-label">Phone Number*</div>
                                <input class="checkout-flow-input w-input" maxlength="16" data-name="phone" placeholder="(XXX) XXX-XXXX" type="text" pattern="[0-9()\s-]*" required  autocomplete="off" inputmode="numeric" v-model="phoneDisplay" @input="handlePhoneInput" :class="{ 'field-error': fieldErrors.phone }">
                                <div class="sms-consent-row" :class="{ 'sms-consent-shake': smsConsentShake, 'sms-consent-row-error': smsConsentError }">
                                    <input type="checkbox" id="checkbox-sms" name="checkbox-sms" class="sms-consent-checkbox" v-model="people.agree_to_phone" @change="smsConsentError = ''">
                                    <label for="checkbox-sms" class="sms-phone-disclaimer">By checking the box, you agree that NewSelf can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.newself.com/privacy-policy" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Privacy Policy</a> and <a href="https://newself.com/terms-of-use" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Terms</a>.</label>
                                </div>
                            </div>
                            <div v-if="showErrorPopup" class="w-form-fail" style="display:block; margin: 0 0 12px; padding: 10px; text-align: center;">
                                <div>{{ errorMessage }}</div>
                            </div>
                            <div class="flow-payment-div">
                                <div class="div-block-2247 phone">
                                    <div v-if="smsConsentError" class="sms-consent-error">{{ smsConsentError }}</div>
                                    <button class="pay-button w-button" @click.prevent="handleSubmit" :disabled="isSubmitting || isCheckingEmail">
                                        <span v-if="isSubmitting || isCheckingEmail">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                                    </animateTransform>
                                                </circle>
                                            </svg>
                                        </span>
                                        <span v-else>Find Your Treatment</span></button>
                                </div>
                            </div>

                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step2_div" v-if="active_el === 6">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Are you currently taking GLP-1 <br>weight loss medication?</div>
                    <div class="text-block-1686">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step2-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form">
                            <div class="flow_choicesdiv">
                                <div class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : isTakingGLP1 === true}" @click="handleGLP1Selection(true)" style="cursor: pointer;">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : isTakingGLP1 === true}"></div><span class="checkout-checkbox-text w-form-label"><strong>Yes</strong>, I&#x27;m currently taking GLP-1 medication<br></span>
                                </div>
                                <div class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : isTakingGLP1 === false}" @click="handleGLP1Selection(false)" style="cursor: pointer;">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : isTakingGLP1 === false}"></div><span class="checkout-checkbox-text w-form-label"><strong>No</strong>, but I would like to start<br></span>
                                </div>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- NEW STEP 13 - Which medication are you taking? -->
            <div class="step2_div" v-if="active_el === 7">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Which medication are you taking?</div>
                    <div class="text-block-1686">Select the weight loss medication you&#x27;re currently using.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step2-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="flow_choicesdiv">
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'semaglutide'}" @click.prevent="handleCurrentMedicationSelection('semaglutide')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : currentMedicationType === 'semaglutide'}"></div><input type="radio" name="checkbox-med" id="checkbox-sema" data-name="Checkbox Semaglutide" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-sema">Semaglutide Compound<br></span>
                                </label>
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'tirzepatide'}" @click.prevent="handleCurrentMedicationSelection('tirzepatide')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : currentMedicationType === 'tirzepatide'}"></div><input type="radio" name="checkbox-med" id="checkbox-tirz" data-name="Checkbox Tirzepatide" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-tirz">Tirzepatide Compound<br></span>
                                </label>
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'mounjaro'}" @click.prevent="handleCurrentMedicationSelection('mounjaro')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : currentMedicationType === 'mounjaro'}"></div><input type="radio" name="checkbox-med" id="checkbox-moun" data-name="Checkbox Mounjaro" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-moun">Mounjaro<br></span>
                                </label>
                                <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'ozempic'}" @click.prevent="handleCurrentMedicationSelection('ozempic')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : currentMedicationType === 'ozempic'}"></div><input type="radio" name="checkbox-med" id="checkbox-ozem" data-name="Checkbox Ozempic" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-ozem">Ozempic<br></span>
                                </label>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step3_div" v-if="active_el === 8">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Ok, choose your dosage</div>
                    <div class="text-block-1686">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="f996d144-0d17-c7eb-11ef-72fe28594767">
                            <div class="flow_choicesdiv">
                                <!-- Semaglutide dosages (for Semaglutide and Ozempic) -->
                                <template v-if="currentMedicationType === 'semaglutide' || currentMedicationType === 'ozempic'">
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '0.25 mg'}" @click.prevent="selectDosage('semaglutide', '0.25 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '0.25 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-025" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-025">Semaglutide <strong>0.25 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '0.5 mg'}" @click.prevent="selectDosage('semaglutide', '0.5 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '0.5 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-05" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-05">Semaglutide <strong>0.5 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '1.0 mg'}" @click.prevent="selectDosage('semaglutide', '1.0 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '1.0 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-10" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-10">Semaglutide <strong>1.0 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '2.0 mg'}" @click.prevent="selectDosage('semaglutide', '2.0 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '2.0 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-175" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-175">Semaglutide <strong>1.75 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '2.5 mg'}" @click.prevent="selectDosage('semaglutide', '2.5 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '2.5 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-25" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-25">Semaglutide <strong>2.5 mg</strong><br></span>
                                    </label>
                                </template>

                                <!-- Tirzepatide dosages (for Tirzepatide and Mounjaro) -->
                                <template v-if="currentMedicationType === 'tirzepatide' || currentMedicationType === 'mounjaro'">
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '2.5 mg'}" @click.prevent="selectDosage('tirzepatide', '2.5 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '2.5 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t25" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t25">Tirzepatide <strong>2.5 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '5.0 mg'}" @click.prevent="selectDosage('tirzepatide', '5.0 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '5.0 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t50" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t50">Tirzepatide <strong>5.0 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '7.5 mg'}" @click.prevent="selectDosage('tirzepatide', '7.5 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '7.5 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t75" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t75">Tirzepatide <strong>7.5 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '10.0 mg'}" @click.prevent="selectDosage('tirzepatide', '10.0 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '10.0 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t10" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t10">Tirzepatide <strong>10 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '12.5 mg'}" @click.prevent="selectDosage('tirzepatide', '12.5 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '12.5 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t125" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t125">Tirzepatide <strong>12.5 mg</strong><br></span>
                                    </label>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : selectedDosage === '15.0 mg'}" @click.prevent="selectDosage('tirzepatide', '15.0 mg')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : selectedDosage === '15.0 mg'}"></div><input type="radio" name="checkbox-dose" id="checkbox-dose-t15" data-name="Checkbox Dose" style="opacity:0;position:absolute;z-index:-1"><span class="checkout-checkbox-text w-form-label" for="checkbox-dose-t15">Tirzepatide <strong>15 mg</strong><br></span>
                                    </label>
                                </template>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step_chooserx_div" v-if="active_el === 9">
                <!-- Loading Overlay -->
                <div v-if="isLoading" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#0c9ac4" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Choose your Treatment</div>
                    <div class="text-block-1686">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-choiceflex-div">
                    <div class="flow-step1-choice">
                        <div class="flow-choice-img-div tirz"><img src="@/assets/images/TirzTilt.webp" loading="lazy" alt="" class="image-680">
                            <div class="choice-pricetag">
                                <div class="pricetag-div">
                                    <div class="text-block-1699">From <span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ lowestTirzPrice.dollars }}<span class="text-span-415"><sup class="superscript-7">{{ lowestTirzPrice.cents }}</sup></span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Trizepatide+</div>
                                    <div class="choice-productsub">COMPOUNDED W/ B6</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="selectMedication('tirzepatide')" :disabled="isLoading">
                                    <span v-if="isLoading && selectedMedication === 'tirzepatide'">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                            <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </span>
                                    <span v-else>Select</span>
                                </button>
                            </div>
                            <p class="paragraph-126 form">The most popular, GLP-2 weight loss program that works on two Glucagon receptor.</p>
                        </div>
                        <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                    </div>
                    <div class="flow-step1-choice">
                        <div class="flow-choice-img-div sema"><img src="@/assets/images/SemaTilt_1.webp" loading="lazy" alt="" class="image-680">
                            <div class="choice-pricetag">
                                <div class="pricetag-div">
                                    <div class="text-block-1700">From <span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ lowestSemaPrice.dollars }}<span class="text-span-415"><sup class="superscript-7">{{ lowestSemaPrice.cents }}</sup></span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Semaglutide+</div>
                                    <div class="choice-productsub">COMPOUNDED W/ B12</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="selectMedication('semaglutide')" :disabled="isLoading">
                                    <span v-if="isLoading && selectedMedication === 'semaglutide'">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                            <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </span>
                                    <span v-else>Select</span>
                                </button>
                            </div>
                            <p class="paragraph-126 form">The original, GLP-1 weight loss program that works on one Glucagon receptor.</p>
                        </div>
                        <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                    </div>
                </div>

                <div class="flow_step-choiceflex-div">
                    <div class="flow-step1-choice">
                        <div class="flow-choice-img-div branded"><img src="@/assets/images/tilted-mounjaro.webp" loading="lazy" alt="" class="image-680">
                            <div class="choice-pricetag branded">
                                <div class="pricetag-div">
                                    <div class="text-block-1699">$1,899<span class="text-span-415"><sup class="superscript-7">97</sup></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Mounjaro™</div>
                                    <div class="choice-productsub">Developed by Eli Lilly™</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="showOutOfStockForMedication('mounjaro')">Select</button>
                            </div>
                            <p class="paragraph-126 form">The most popular dual-action GLP-1 weight loss program with enhanced metabolic support.</p>
                        </div>
                        <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                    </div>
                    <div class="flow-step1-choice">
                        <div class="flow-choice-img-div branded"><img src="@/assets/images/tilted-ozempic.webp" loading="lazy" alt="" class="image-680">
                            <div class="choice-pricetag branded">
                                <div class="pricetag-div">
                                    <div class="text-block-1700">$1,495<span class="text-span-415"><sup class="superscript-7">97</sup></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Ozempic™</div>
                                    <div class="choice-productsub">Developed by Novo Nordisk™</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="showOutOfStockForMedication('ozempic')">Select</button>
                            </div>
                            <p class="paragraph-126 form">A leading GLP-1 weight loss program that targets appetite regulation.</p>
                        </div>
                        <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                    </div>
                </div>
            </div>
            
            <div class="step4_div" v-if="active_el === 10">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">More than Just Medication.</div>
                    <!--<div class="text-block-1713">The NewSelf Weight Loss Protocol is more than just medication, it is a full health optimization system to help you live better...longer.</div>-->
                    <div class="flow_inclusions-div">
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="getMedicationDetails().image" loading="lazy" alt="" ></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">{{ getMedicationDetails().name }}</div>
                                    <p class="inclusions-subs">Personalized Compounded GLP&nbsp;Medication - Subcutaneous </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="div-block-2249 top-float">
                                <div class="text-block-1710 hide-mobile" style="text-decoration:none;">As low as</div>
                                <div class="text-block-1711-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ selectedMedication === 'semaglutide' ? lowestSemaPrice.dollars : lowestTirzPrice.dollars }}<span><sup class="superscript-11">{{ selectedMedication === 'semaglutide' ? lowestSemaPrice.cents : lowestTirzPrice.cents }}</sup></span></span><span class="text-span-420">a month</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_stetoscope.webp" loading="lazy" alt="" class="image-681"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Doctor Review</div>
                                    <p class="inclusions-subs">A doctor will review your intake, and prescribe (if appropriate) today! </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_discount.webp" loading="lazy" alt="" class="image-682"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Discounted Therapies</div>
                                    <p class="inclusions-subs">Accelerate your results and reduce side effects with additional treatment plans.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/WeightSteps_Plan2.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/WeightSteps_Plan2-p-500.webp 500w, @/assets/images/WeightSteps_Plan2-p-800.webp 800w, @/assets/images/WeightSteps_Plan2.webp 1080w" alt="" class="image-684"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Metabolic Weight Plan</div>
                                    <p class="inclusions-subs">A Personalized weight loss plan to help you lose weight faster and keep it off. </p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_van.webp" loading="lazy" alt="" class="image-683"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Overnight Cold Shipping</div>
                                    <p class="inclusions-subs">We ship all medications <strong>next-day on cold packs</strong> to keep them stable and effective.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/Doctor_newself.webp" loading="lazy" sizes="(max-width: 755px) 100vw, 755px" srcset="@/assets/images/Doctor_newself-p-500.webp 500w, @/assets/images/Doctor_newself.webp 755w" alt="" class="image-694"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Ongoing Doctor Support</div>
                                    <p class="inclusions-subs">Our doctors provide ongoing support and quarterly checkins to monitor your progress.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                    </div>
                    <div class="format-divider"></div>
                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="div-block-2250"><img src="@/assets/images/icon_tag.svg" loading="lazy" alt="" class="image-688">
                                <div class="text-block-1722">Summer Sale</div>
                            </div>
                            <div class="text-block-1710" style="text-decoration:none;">As low as</div>
                            <div class="text-block-1711-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ selectedMedication === 'semaglutide' ? lowestSemaPrice.dollars : lowestTirzPrice.dollars }}<span><sup class="superscript-11">{{ selectedMedication === 'semaglutide' ? lowestSemaPrice.cents : lowestTirzPrice.cents }}</sup></span></span><span class="text-span-420"> a month</span></div>
                        </div>
                    </div>
                    <div class="flow-ctrls-div continue-everything" style="justify-content: center;">
                        <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="advanceStep">Continue <span class="text-span-423">-&gt;</span></a>
                    </div>
                    <div class="trust-pilot-div"><img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
                        <div class="flow-rating-div">
                            <div class="text-block-1723">Excellent</div>
                            <div class="text-block-1724">4.6 out of 5</div><img src="@/assets/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/Trustpilot_Logo_2022.svg-p-500.webp 500w, @/assets/images/Trustpilot_Logo_2022.svg-p-800.webp 800w, @/assets/images/Trustpilot_Logo_2022.svg-p-1080.webp 1080w, @/assets/images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="image-690">
                        </div>
                        <div>Trusted by thousands of members</div>
                    </div>

                </div>
            </div>
            <div class="step5_div" v-if="active_el === 11">
                <!-- Loading Overlay -->
                <div v-if="submitted" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Complete your order</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>

                <div class="flow_step5-choiceflex-div" >
                    <!-- Payment Plan Selection -->
                    <div class="flow-payplan-div">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                <div class="flow_payplan_select">

                                    <!-- Selected Medication Display -->
                                    <div class="order-item-flex">
                                        <div class="div-block-2241">
                                            <div class="product-box-flex">
                                                <div class="product-name-and-sub">
                                                    <div class="text-block-1690">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}<span class="text-span-422">+</span></div>
                                                    <div class="text-block-1691">COMPOUNDED W/ {{ selectedMedication === 'semaglutide' ? 'B12' : 'B6' }}</div>
                                                </div>
                                                <div v-if="nextThreeMonthDoses" class="checkout-dosage-div">
                                                    <div class="checkout---month-dose" v-for="monthDose in nextThreeMonthDoses" :key="monthDose.month">
                                                        <div class="text-block-1715">MONTH {{ monthDose.month }}</div>
                                                        <div class="text-block-1717">{{ monthDose.dose }} <span class="text-span-421">MG</span></div>
                                                        <div class="text-block-1715">Weekly Dose</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1693">All Dosages are same price. Meet w/ provider to personalize plan.</div>
                                        </div>
                                        <div class="order_img_div">
                                            <img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" />

                                        </div>
                                    </div>
                                    <!--<label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===0}" @click="changePaymentTerms(0)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===0}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="0" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <strong>${{ formatDollars(getTotalPrice(0)) }}</strong>
                                            <span class="text-span-416"><strong><sup>{{ (getTotalPrice(0) % 1).toFixed(2).split('.')[1] }}</sup></strong></span>
                                            <span class="text-span-417"> 1 Month Supply.</span><br>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">One Time Purchase</div>
                                        </div>
                                    </label>

                                    <div class="text-block-1697">Sign up for other options and save.</div>-->

                                    <!-- Payment Plan Options -->
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===1}" @click="changePaymentTerms(1)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===1}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="1" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getFirstMonthPrice()) }}</strong><span class="text-span-416"><strong><sup>{{ (getFirstMonthPrice() % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                            <span class="text-span-417">/mo <br> <span class="tosspan">*3 month supply paid monthly. No credit checks or financing charges.</span></span>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">Recurring</div>
                                        </div>
                                    </label>
                                    

                                    <div class="text-block-1697">Stay committed longer, save more.</div>
                                    <div class="plans-div">
                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===3}" @click="changePaymentTerms(3)">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===3}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="3" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(3) / 3) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(3) / 3) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (3 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(getTotalPrice(3)) }}</span> today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===6}" @click="changePaymentTerms(6)">
                                            <span class="plan-badge plan-badge--popular">Popular</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===6}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="6" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(6) / 6) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(6) / 6) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (6 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(getTotalPrice(6)) }}</span> today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===12}" @click="changePaymentTerms(12)">
                                            <span class="plan-badge plan-badge--recommended">Recommended</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===12}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="12" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(12) / 12) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(12) / 12) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (12 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(getTotalPrice(12)) }}</span> today</div>
                                                <SummerSaleBadge style="margin-top: 1px; margin-bottom: 8px;" />
                                            </div>
                                        </label>

                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="flow-ctrls-div" style="justify-content: center;">
                            <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="continueFromStep17">Continue <span class="text-span-423">-&gt;</span></a>
                        </div>
                    </div>
                    

                   
                    <div class="flow-pay-summary hide-in-mobile">
                        <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="17a32de0-f4b2-ba0e-e661-91591044c4c7" aria-label="Email Form">
                            <div class="flow-sum-maindiv">
                            <div class="flow-summary-top">
                                <div class="text-block-1688-copy">Order Summary</div>
                            </div>
                            <div class="flow-sum-orders-div">
                                <!-- With the free NAD+ in, both lines carry their picture. -->
                                <div class="order-line-div" :class="{ 'order-line-pic': offerNadLine }">
                                <div class="order-name"><img v-if="offerNadLine" :src="getMedicationDetails().straightImage" alt="" class="order-line-img">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                <div class="div-block-2243">
                                    <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                </div>
                                </div>
                                <!-- The free NAD+ line from the lander's offer link -->
                                <div v-if="offerNadLine" class="order-line-div order-line-pic">
                                <div class="order-name"><img :src="nadFreeImage" alt="" class="order-line-img">{{ offerNadName }}</div>
                                <div class="div-block-2243">
                                    <div class="order-price">${{ formatDollars(offerNadLine.price) }}<sup class="superscript-9">{{ (offerNadLine.price % 1).toFixed(2).split('.')[1] }}</sup></div>
                                </div>
                                </div>
                            </div>
                            <div class="order-total-div">
                                <div class="text-block-1698">Due today</div>
                                <div class="div-block-2243">
                                <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9-copy">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                </div>
                            </div>
                            <div class="flow-sum-guarantee-div">
                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you're not eligible, we'll issue a full refund</p>
                            </div>
                            </div>
                        </form>
                        <div class="w-form-done" tabindex="-1" role="region" aria-label="Email Form success">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="step6_div" v-if="active_el === 12">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Payment details</div>

                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="5e212543-757c-9c76-d0d5-ebcebbfcc5e5">
                            <div class="flow-payment-div" :class="{'dropdown-expanded': summeryOpen}">
                                <div data-hover="false" data-delay="0" class="flow-dropdown-sum w-dropdown" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                    <div class="flow-sum-droptoggle w-dropdown-toggle" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                        <div class="icon-49 w-icon-dropdown-toggle"></div>
                                        <div class="drop-sum-label-div div-block-2244">
                                            <div class="text-block-1701">Due Today </div>
                                            <div class="text-block-1701"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span class="text-span-418"><sup>{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                        </div>
                                    </div>
                                    <div class="dropdown-list-18 w-dropdown-list" :class="{'w--open' : summeryOpen}">
                                        <div class="flow-sum-maindiv">
                                            <div class="flow-summary-top">
                                                <div class="text-block-1688-copy">Order Summary</div>
                                            </div>
                                            <div class="flow-sum-orders-div">
                                                <!-- With the free NAD+ in, both lines carry their picture. -->
                                                <div class="order-line-div" :class="{ 'order-line-pic': offerNadLine }">
                                                    <div class="order-name"><img v-if="offerNadLine" :src="getMedicationDetails().straightImage" alt="" class="order-line-img">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                                    <div class="div-block-2243">
                                                        <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                    </div>
                                                </div>
                                                <!-- The free NAD+ line from the lander's offer link -->
                                                <div v-if="offerNadLine" class="order-line-div order-line-pic">
                                                    <div class="order-name"><img :src="nadFreeImage" alt="" class="order-line-img">{{ offerNadName }}</div>
                                                    <div class="div-block-2243">
                                                        <div class="order-price">${{ formatDollars(offerNadLine.price) }}<sup class="superscript-9">{{ (offerNadLine.price % 1).toFixed(2).split('.')[1] }}</sup></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="order-total-div">
                                                <div class="text-block-1698">Due today</div>
                                                <div class="div-block-2243">
                                                    <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<sup class="superscript-9-copy">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1705">What&#x27;s included</div>
                                            <div class="inclusions-new">
                                                <div class="flow_inclusions-div">
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" loading="lazy" alt="" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                                                <p class="inclusions-subs" v-if="paymentInfo.payment_terms===12">3 Vials Every 90 Days for a Year.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===6">3 month supply now, 3 more in 90 days.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===3">3 month supply.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===0">1 Month Supply</p>
                                                                <p class="inclusions-subs" v-else>3 Month Supply Paid Monthly</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <!-- The free NAD+ from the lander's offer link, with its picture. -->
                                                    <div class="flow-inclusion-entry-div" v-if="offerNadLine">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="nadFreeImage" loading="lazy" alt="" class="image-681 inclusion-nad-img"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">{{ offerNadName }}</div>
                                                                <p class="inclusions-subs">{{ offerNadLabel }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_stetoscope.webp" loading="lazy" alt="" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Doctor Support &amp; Monitoring</div>
                                                                <p class="inclusions-subs">Consult with Board-certified experts</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_van.webp" loading="lazy" alt="" class="image-683"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Express Shipping</div>
                                                                <p class="inclusions-subs">We ship all medications next-day on cold packs.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-2248">
                                                    <div class="text-block-1712">Total</div>
                                                    <div class="div-block-2249">
                                                        <div class="text-block-1711"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span><sup class="superscript-11">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flow-sum-guarantee-div">
                                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you&#x27;re not eligible, we&#x27;ll issue a full refund</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Price breakdown. Visible without expanding the Due Today
                                     dropdown so the sub-price is never a surprise. Subtotal is
                                     gross and the Discount row is the exact difference, so the
                                     rows always sum to Total. -->
                                <div class="ft-sum-breakdown">
                                    <!-- On a free NAD+ link: the GLP-1 and the NAD+ as stacked cards, so
                                         the shopper sees both products. Outside the Due Today details,
                                         so they show on every screen size. -->
                                    <div class="ft-card" v-if="offerNadLine">
                                        <img :src="getMedicationDetails().straightImage" :alt="getMedicationDetails().name" class="ft-card-img">
                                        <div class="ft-card-body">
                                            <div class="ft-card-name">{{ getMedicationDetails().name }}</div>
                                            <div class="ft-card-sub">{{ paymentInfo.payment_terms }} mo plan · all doses same&nbsp;price</div>
                                        </div>
                                        <div class="ft-card-price">${{ formatPrice(getTotalPrice(paymentInfo.payment_terms) / paymentInfo.payment_terms) }}<span class="ft-card-per">/mo</span></div>
                                    </div>
                                    <div class="ft-card" v-if="offerNadLine">
                                        <img :src="nadFreeImage" :alt="offerNadName" class="ft-card-img">
                                        <div class="ft-card-body">
                                            <div class="ft-card-name">{{ offerNadName }}</div>
                                            <div class="ft-card-sub">{{ offerNadLabel }}</div>
                                            <div v-if="offerNadNote" class="ft-card-sub ft-card-note">{{ offerNadNote }}</div>
                                        </div>
                                        <div class="ft-card-price ft-card-free">${{ formatPrice(offerNadLine.price) }}</div>
                                    </div>
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Shipping</span>
                                        <span class="ft-sum-value">FREE</span>
                                    </div>
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Subtotal</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(getCurrentPrice()) }}</span>
                                    </div>
                                    <div class="ft-sum-row" v-if="summaryDiscount > 0">
                                        <span class="ft-sum-label">Discount</span>
                                        <span class="ft-sum-value">-${{ formatPrice(summaryDiscount) }}</span>
                                    </div>
                                    <div class="ft-sum-row ft-sum-total">
                                        <span class="ft-sum-label">Total</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPrice(displayTotal) }}</span>
                                    </div>
                                </div>

                                <div class="form-field-label">Coupon Code</div>
                                <div class="div-block-2246">
                                    <input class="text-field-68 w-input" maxlength="256" :class="{'field-error' : couponError}" name="field" data-name="Field" v-model="paymentInfo.couponCode" placeholder="Optional Coupon Code" type="text" id="field" :disabled="couponApplied">
                                    <a href="#" @click.prevent="handleCouponSubmit" class="button-172 w-button" :class="{'disabled': couponApplied}">{{ couponApplied ? 'Applied' : 'Apply' }}</a>
                                </div>

                                <div class="text-block-1704">Payment Method</div>

                                <!-- Express Checkout (Klarna) -->
                                <div class="express-checkout-section">
                                  <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }">
                                    <express-checkout-button
                                        :amount="walletSheetAmountInCents"
                                        @token="handleExpressPayment"
                                        @can-make-payment="canMakeExpressCheckout = $event"
                                    />
                                    <button v-if="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                      <span class="klarna-btn-text">Buy now, pay later with</span>
                                      <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                    </button>
                                  </div>
                                  <div class="pe-divider">
                                    <div class="pe-divider-line"></div>
                                    <span>OR</span>
                                    <div class="pe-divider-line"></div>
                                  </div>
                                </div>

                              
                                <!-- Stripe Payment Element (card + Apple Pay + Google Pay) -->
                                <stripe-payment-element
                                    ref="stripePayment"
                                    :base-url="baseUrl"
                                    :user-id="user?.id"
                                    :user-name="`${people.first_name} ${people.last_name}`.trim()"
                                    :user-email="people.email"
                                    :hide-address-fields="true"
                                    :billing-address="customerInfo"
                                    @ready="hasCardInput = $event"
                                    @error="handlePaymentError"
                                    @token="handlePaymentToken"
                                />

                                <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                <div :class="{ 'address-highlight': addressBlink }">
                                    <google-places-autocomplete-new :api-key="googleMapsApiKey" @address-updated="getAddressData" border-color="var(--ce-grey)" />
                                </div>

                                <!-- Payment Error Display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block; margin-top: 15px; margin-bottom: 15px;">
                                    <div>{{ errorMessage }}</div>
                                </div>

                                <div class="div-block-2247">
                                    <button type="button" @click.prevent="getStripeToken" :disabled="submitted" class="pay-button w-button">
                                        {{ submitted ? 'Processing...' : 'Pay' }}
                                    </button>
                                    <p class="paragraph-185-copy">
                                        By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the
                                        <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                        <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>,
                                        <a href="https://newself.com/hipaa" target="_blank">HIPAA Notice</a>, and
                                        <a href="https://newself.com/telehealth-consent" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
    <PaidUserModal
        :visible="showPaidUserModal"
        :email="people.email"
        :reason="paidUserReason"
        :role="paidUserRole"
        @close="showPaidUserModal = false" />

    <!-- Priority Physician Review — offered once the order is captured, never before -->
    <fast-track-upsell-modal
        v-if="fastTrackOffer"
        :addon="fastTrackAddon"
        :payment-method="fastTrackOffer.paymentMethod"
        :context="fastTrackOffer"
        @shown="onFastTrackShown"
        @purchased="onFastTrackPurchased"
        @done="onFastTrackDone"
    />
</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js"
import { cleanUsPhone, cleanUsPhoneInput, formatUsPhone, isValidUsPhone } from '@/utils/phone'
let stripe = null;
import GooglePlacesAutocompleteNew from '../common/GooglePlacesAutocomplete_new.vue'
import StripePaymentElement from '../common/StripePaymentElement.vue'
import ExpressCheckoutButton from '../common/ExpressCheckoutButton.vue'
import fastTrackUpsell from '@/mixins/fastTrackUpsell.js'
import freeNadLifeOffer from '@/mixins/freeNadLifeOffer.js'
import { stashKlarnaPurchase } from '@/utils/klarnaPurchaseTracking.js'
import { offerQuery } from '@/utils/freeNadLifeOffer.js'
import state from "@/utils/state.json"
import {
    mapActions,
    mapGetters
} from 'vuex'
import {
    getProductsById
} from '@/utils/productData'
import { checkEmail, isValidEmailFormat } from '@/utils/checkEmail';
import PaidUserModal from '../common/PaidUserModal.vue';

export default {
    name: 'WeightLossCheckoutFlow',
    mixins: [fastTrackUpsell, freeNadLifeOffer],
    fastTrackFunnelStep: 16,
    fastTrackForm: "glp1_v2",
    components: {
        GooglePlacesAutocompleteNew,
        PaidUserModal,
        StripePaymentElement,
        ExpressCheckoutButton
    },
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            allState: state,
            active_el: 3,
            totalSteps: 13,
            formErrors: {},
            fieldErrors: {},
            smsConsentError: '',
            smsConsentShake: false,
            isSubmitting: false,
            emailCheckError: '',
            isCheckingEmail: false,
            showPaidUserModal: false,
            paidUserReason: 'paid_user',
            paidUserRole: '',
            showErrorPopup: false,
            errorMessage: '',
            summeryOpen: false,
            hasCardInput: false,

            submitted: false,
            correlationId: null,
            paymentError: false,
            selectedMedication: '',
            selectedDosage: '',
            previousMedication: null,
            previousDosage: null,
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            couponError: false,
            couponValid: false,
            couponApplied: false,
            isTakingGLP1: null, // null = not answered, true = taking, false = not taking
            currentMedicationType: '', // Which medication they're currently taking (semaglutide, tirzepatide, mounjaro, ozempic)
            cartId: '',
            isLoading: false,
            showOutOfStockModal: false,
            addressBlink: false,
            canMakeExpressCheckout: false,

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 12, // default to the Recommended (12-month) plan
                user_id: '',
                cardToken: '',
                cardBrand: '',
                amount: 0,
                discount: 0,
                medication: '',
                couponCode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
            },
            pricingConfig: JSON.parse(process.env.VUE_APP_PRICING || '{"semaglutide":{"monthly":{"first":194.97,"regular":194.97},"terms":{"3":449.91,"6":749.82,"12":1199.64, "0": 209.97}},"tirzepatide":{"monthly":{"first":274.97,"regular":274.97},"terms":{"3":644.91,"6":1169.82,"12":2099.64, "0": 294.97}}}'),
            // Live plans from /api/get-all-plans keyed by payment_terms: { id, price }.
            // Empty until loadPlans resolves; on fetch failure it stays empty so pricing
            // falls back to pricingConfig and planId falls back to paymentInfo.planId.
            apiPlans: {},
            // The term add_to_cart last reported. A plan tile is a <label> wrapping its
            // radio, so one shopper click reaches changePaymentTerms twice and would
            // otherwise send the same event twice, one millisecond apart.
            lastTrackedTerm: null,
            // Screens whose questionnaire events have already gone out. The Back button
            // lets a shopper re-submit a screen, and every re-submit would otherwise
            // send that screen's events again.
            trackedSteps: [],
            // Product ObjectIds per medication (the same ids createAndSaveCart carts, so the
            // hero "as low as" price is fetched for the exact product the checkout charges).
            medProductIds: {
                semaglutide: '675ac4cb6bf102c19ec3afec',
                tirzepatide: '675ac4cb6bf102c19ec3afe9',
            },
            // Lowest live promo price (12-month total) per med for the "as low as" hero.
            // null until loadLowestPromoPrices resolves; on any miss the hero falls back to
            // pricingConfig, so the display never fabricates a price.
            promoLowest: {
                semaglutide: null,
                tirzepatide: null,
            },
            // Gates the price display until the live fetches settle, so the env
            // fallback price never flashes on screen before the real one loads.
            pricesReady: false,
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            },

            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                zip: '',
                apt: '',
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                desired_weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agree_to_phone: false,
                state: '',
                agreed_to_terms: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                user_agent: "",
                ip_address: '',
                tracking_session_id: '',
                age: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                categories: {
                    weightLoss: false,
                    longevity: false,
                    mind: false,
                    wellness: false
                },
                healthConditions: {
                    none: false,
                    pregnant: false,
                    breastfeeding: false,
                    kidneyDisease: false,
                    liverDisease: false,
                    eatingDisorder: false,
                    suicidal: false,
                    cancer: false,
                    organTransplant: false,
                    gastrointestinal: false,
                    substanceAbuse: false,
                    thyroidCancer: false,
                    type2Diabetes: false,
                    type1Diabetes: false,
                    diabeticRetinopathy: false,
                    warfarin: false,
                    pancreatitis: false,
                    streetDrugs: false
                }
            }
        }
    },
    async mounted() {
        window.addEventListener('pageshow', this.handlePageShow);
        // Load saved progress from session storage
        this.loadProgress();
        // After loadProgress, so a shopper restored onto a later screen does not
        // report starting the questionnaire a second time.
        this.fireQuestionnaireStart();

        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
        // Load live promo prices (hero "as low as") + live plan prices (plan cards +
        // order summary) together, then reveal prices so neither flashes the env
        // fallback on a refresh-restore before the live numbers land.
        await Promise.all([this.loadLowestPromoPrices(), this.loadPlans()]);
        this.pricesReady = true;

        await this.initStripe();
        this.prefillFromUserData();
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },
    computed: {
        ...mapGetters(['user', 'isAuthenticated', 'cartItems', 'cartTotal', 'cartTotalNoDiscount']),

        lowestSemaPrice() {
            const total = this.promoLowest.semaglutide != null
                ? this.promoLowest.semaglutide
                : this.pricingConfig.semaglutide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },
        lowestTirzPrice() {
            const total = this.promoLowest.tirzepatide != null
                ? this.promoLowest.tirzepatide
                : this.pricingConfig.tirzepatide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },

        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },

        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },

        phoneDisplay: {
            get() {
                // Show an optional "1 " country code, e.g. "1 (555) 555-5555"
                return formatUsPhone(this.people.phone);
            },
            set(value) {
                // Keep an optional leading 1 country code; cap national part at 10
                this.people.phone = cleanUsPhoneInput(value);
            }
        },

        bmi_calculated() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                return ((weightInPounds * 703) / (heightInInches * heightInInches)).toFixed(2);
            }
            return "";
        },

        // Payment-related computed properties
        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },

        // What the Apple/Google Pay sheet shows. Display only: the express element is
        // created with paymentMethodCreation:'manual', so it tokenizes and never charges.
        // amountInCents is already net of any coupon here (getTotalOrderAmount subtracts it).
        walletSheetAmountInCents() {
            return this.amountInCents;
        },
        // What the customer sees as their total.
        displayTotal() {
            return this.getTotalOrderAmount();
        },
        // Discount actually applied, taken as the difference rather than from
        // paymentInfo.discount — getTotalOrderAmount clamps at 0, so a coupon larger
        // than the plan price would otherwise make the summary rows disagree.
        summaryDiscount() {
            return parseFloat((this.getCurrentPrice() - this.getTotalOrderAmount()).toFixed(2));
        },

        selectedPlanId() {
            // Plan ObjectId for the selected term (backend charges the plan price off this)
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : this.paymentInfo.planId;
        },

        // What the free NAD+ offer (freeNadLifeOffer mixin) checks the order against:
        // the GLP-1 in the cart, which is what the order charges.
        offerGlpProductId() {
            const main = this.cartItems.find((item) => !item.is_addon) || this.cartItems[0];
            return main ? main.id : null;
        },
        offerGlpTerms() {
            return this.paymentInfo.payment_terms;
        },

        getProductPricingData() {
            return this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
        },

        nextThreeMonthDoses() {
            if (!this.selectedDosage || !this.selectedMedication) {
                return null;
            }

            // Define titration schedules for each medication
            const semaglutideDoses = ['0.25 mg', '0.5 mg', '1.0 mg', '2.0 mg', '2.5 mg'];
            const tirzepatideDoses = ['2.5 mg', '5.0 mg', '7.5 mg', '10.0 mg', '12.5 mg', '15.0 mg'];

            let currentMedication = this.selectedMedication;
            let currentDosage = this.selectedDosage;
            let doses = currentMedication === 'semaglutide' ? semaglutideDoses : tirzepatideDoses;
            let currentIndex = doses.findIndex(dose => dose === currentDosage);

            if (currentIndex === -1) return null;

            const result = [];
            const newHighestDoseIndex = doses.length - 1;

            // Check if staying on same medication (titrate up) or switching (start at current dose)
            const isStayingOnSameMed = (
                (this.currentMedicationType === 'semaglutide' || this.currentMedicationType === 'ozempic') &&
                currentMedication === 'semaglutide'
            ) || (
                (this.currentMedicationType === 'tirzepatide' || this.currentMedicationType === 'mounjaro') &&
                currentMedication === 'tirzepatide'
            );

            // If staying on same medication, titrate up (start from next dose)
            // If switching medications, start from mapped dose
            const startOffset = isStayingOnSameMed ? 1 : 0;

            // Start from current dose (or next dose if titrating) and show next 3 months
            for (let i = 0; i < 3; i++) {
                const monthNumber = i + 1;
                const doseIndex = currentIndex + startOffset + i;

                // If dose index exceeds array, use the highest dose available
                const effectiveDoseIndex = Math.min(doseIndex, newHighestDoseIndex);
                const doseValue = doses[effectiveDoseIndex];
                const numericDose = parseFloat(doseValue);

                result.push({
                    month: monthNumber,
                    dose: numericDose,
                    isHighest: effectiveDoseIndex === newHighestDoseIndex
                });
            }

            return result;
        }
    },
    methods: {
        ...mapActions(['setCartVisibility', 'addToCart', 'clearCart']),

        async checkEmailOnBlur() {
            this.emailCheckError = '';
            if (!this.people.email || !isValidEmailFormat(this.people.email)) {
                return;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                }
            } catch (e) {
                // Never block on error
            } finally {
                this.isCheckingEmail = false;
            }
        },
        async handleEmailCheck() {
            this.emailCheckError = '';
            if (!isValidEmailFormat(this.people.email)) {
                return true;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                    return false;
                }
                return true;
            } catch (e) {
                return true;
            } finally {
                this.isCheckingEmail = false;
            }
        },

        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
                await this.initStripe();
                this.$nextTick(() => {
                    if (this.$refs.stripePayment) {
                        this.$refs.stripePayment.resetElement();
                    }
                });
            }
        },

        // Save checkout progress to session storage
        saveProgress() {
            try {
                const progressData = {
                    active_el: this.active_el,
                    people: this.people,
                    selectedMedication: this.selectedMedication,
                    selectedDosage: this.selectedDosage,
                    currentMedicationType: this.currentMedicationType,
                    isTakingGLP1: this.isTakingGLP1,
                    paymentInfo: this.paymentInfo,
                    // Carried across a refresh so a shopper who reloads and then walks
                    // back through a screen does not report that screen twice.
                    trackedSteps: this.trackedSteps,
                    timestamp: Date.now()
                };
                sessionStorage.setItem('weightLossCheckoutV2Progress', JSON.stringify(progressData));
            } catch (error) {
                console.error('Error saving progress:', error);
            }
        },

        // Load checkout progress from session storage
        loadProgress() {
            try {
                const savedProgress = sessionStorage.getItem('weightLossCheckoutV2Progress');
                if (savedProgress) {
                    const progressData = JSON.parse(savedProgress);

                    // Only restore if saved within last 24 hours
                    const dayInMs = 24 * 60 * 60 * 1000;
                    if (Date.now() - progressData.timestamp < dayInMs) {
                        const restoredStep = parseInt(progressData.active_el);
                        this.active_el = (restoredStep >= 3 && restoredStep <= 12) ? restoredStep : 3;
                        this.people = {
                            ...this.people,
                            ...progressData.people
                        };
                        this.selectedMedication = progressData.selectedMedication || '';
                        this.selectedDosage = progressData.selectedDosage || '';
                        this.currentMedicationType = progressData.currentMedicationType || '';
                        this.isTakingGLP1 = progressData.isTakingGLP1;
                        this.trackedSteps = Array.isArray(progressData.trackedSteps) ? progressData.trackedSteps : [];
                        if (progressData.paymentInfo) {
                            // Restore saved payment info but keep the Recommended (12-month)
                            // plan selected by default — never resurrect a stale term choice.
                            // eslint-disable-next-line no-unused-vars
                            const { payment_terms, ...restPaymentInfo } = progressData.paymentInfo;
                            this.paymentInfo = {
                                ...this.paymentInfo,
                                ...restPaymentInfo
                            };
                        }
                        console.log('Progress restored from session storage');
                    } else {
                        // Clear expired data
                        sessionStorage.removeItem('weightLossCheckoutV2Progress');
                    }
                }
            } catch (error) {
                console.error('Error loading progress:', error);
            }
        },

        // Clear saved progress
        clearProgress() {
            try {
                sessionStorage.removeItem('weightLossCheckoutV2Progress');
            } catch (error) {
                console.error('Error clearing progress:', error);
            }
        },

        clampInches() {
            // First filter out non-numeric characters
            const cleaned = this.people.height.inches.replace(/\D/g, '');
            this.people.height.inches = cleaned;
            
            // Then clamp to maximum of 11
            const val = parseInt(this.people.height.inches);
            if (!isNaN(val) && val > 11) {
                this.people.height.inches = '11';
            }
        },

        validateNumericInput(event, max) {
            let value = event.target.value.replace(/\D/g, '');
            if (max !== undefined && value !== '' && parseInt(value) > max) {
                value = String(max);
            }
            if (event.target.value !== value) {
                event.target.value = value;
                event.target.dispatchEvent(new Event('input', { bubbles: true }));
            }
        },
        autoAdvanceDobField(currentFieldId, nextFieldId, maxLength) {
            const currentField = document.getElementById(currentFieldId);
            if (currentField && currentField.value.length === maxLength) {
                const nextField = document.getElementById(nextFieldId);
                if (nextField) {
                    nextField.focus();
                }
            }
        },
        getDaysInMonth(month, year) {
            if (!month) return 31;
            const m = parseInt(month);
            if ([4, 6, 9, 11].includes(m)) return 30;
            if (m === 2) {
                const y = parseInt(year);
                if (!y || year.length < 4) return 29;
                return (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) ? 29 : 28;
            }
            return 31;
        },
        clampDayToMonth() {
            const dd = parseInt(this.people.dob.dd);
            if (!dd) return;
            const maxDay = this.getDaysInMonth(this.people.dob.mm, this.people.dob.yyyy);
            if (dd > maxDay) {
                this.people.dob.dd = String(maxDay);
            }
        },
        handleDobInput(event, field, currentFieldId, nextFieldId, maxLength) {
            let value = event.target.value.replace(/\D/g, '');

            if (field === 'mm') {
                if (value.length === 2) {
                    const num = parseInt(value);
                    if (num < 1) value = '01';
                    else if (num > 12) value = '12';
                }
                this.people.dob.mm = value;
                this.$nextTick(() => this.clampDayToMonth());
            } else if (field === 'dd') {
                if (value.length === 2) {
                    const num = parseInt(value);
                    const maxDay = this.getDaysInMonth(this.people.dob.mm, this.people.dob.yyyy);
                    if (num < 1) value = '01';
                    else if (num > maxDay) value = String(maxDay);
                }
                this.people.dob.dd = value;
            } else if (field === 'yyyy') {
                this.people.dob.yyyy = value;
                if (value.length === 4) {
                    this.$nextTick(() => this.clampDayToMonth());
                }
            }

            event.target.value = value;

            if (nextFieldId) {
                this.autoAdvanceDobField(currentFieldId, nextFieldId, maxLength);
            }
        },
        handleHeightFeetInput(event) {
            this.validateNumericInput(event, 8);
            if (this.people.height.foot && this.people.height.foot.length === 1) {
                this.$nextTick(() => {
                    const inchesField = document.getElementById('height-inches');
                    if (inchesField) inchesField.focus();
                });
            }
        },
        handleInchesInput(event) {
            this.validateNumericInput(event, 11);
            if (this.people.height.inches && this.people.height.inches.length === 2) {
                this.$nextTick(() => {
                    const weightField = document.getElementById('Weight-pounds');
                    if (weightField) weightField.focus();
                });
            }
        },
        handleWeightInput(event) {
            // Filter out non-numeric characters
            const value = event.target.value.replace(/\D/g, '');
            this.people.weight = value;
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.paymentInfo.couponCode) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if (response.data.c_type === 2) {
                        // Calculate percentage-based discount
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    } else {
                        this.paymentInfo.discount = response.data.c_val;
                    }

                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },
        handlePhoneInput(event) {
            // Cap to 10 digits, then force the displayed value so extra
            // keystrokes can't linger past the cap.
            this.people.phone = cleanUsPhoneInput(event.target.value);
            event.target.value = formatUsPhone(this.people.phone);
        },

        unformatPhoneDisplay() {
            // Keep formatted display when focusing
        },

        formatPhoneDisplay() {
            // Already formatted as they type
        },

        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },

        setFieldError(field, hasError = true) {
            this.$set(this.fieldErrors, field, hasError);
        },

        GoBack() {
            if (this.active_el > 1) {
                if (this.active_el === 9 && this.isTakingGLP1 === false) {
                    this.active_el = 6;
                } else {
                    this.active_el--;
                }
                this.fieldErrors = {};
            }
        },

        selectDosage(medication, dosage) {
            // Medication switching mapping
            const withinTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose when switching from Tirzepatide to Semaglutide
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 7.5, // S4 -> T3
                    1.75: 7.5, // S4 -> T3 (alternative format)
                    2.0: 7.5, // S5 -> T3
                    2.4: 10.0, // S6 -> T4
                    2.5: 10.0 // S6 -> T4
                }
            };

            // Check if switching medications
            if (this.selectedMedication && this.selectedDosage && this.selectedMedication !== medication) {
                const currentDoseValue = parseFloat(this.selectedDosage);
                const previousMed = this.selectedMedication;

                // Apply medication switching mapping
                if (withinTwoWeeksMap[previousMed] && withinTwoWeeksMap[previousMed][currentDoseValue]) {
                    const mappedDose = withinTwoWeeksMap[previousMed][currentDoseValue];
                    dosage = mappedDose + ' mg';
                } else {
                    // Fallback to starter doses if mapping not found
                    dosage = medication === 'semaglutide' ? '0.25 mg' : '2.5 mg';
                }
            }

            // Store previous selection for potential future use
            this.previousMedication = this.selectedMedication;
            this.previousDosage = this.selectedDosage;

            // Update current selection
            this.selectedMedication = medication;
            this.selectedDosage = dosage;
            // Advance to next step after a brief delay so user sees their selection
            setTimeout(() => {
                this.active_el++;
            }, 300);
        },

        handleGLP1Selection(isTaking) {
            this.isTakingGLP1 = isTaking;
            console.log(isTaking)
            // Check BMI qualification
            const bmi = parseFloat(this.bmi_calculated);

            if (isNaN(bmi) || bmi <= 0) {
                this.showError('Please complete the height and weight fields first.');
                return;
            }

            // Qualification logic:
            // - Not taking GLP-1: BMI must be >= 25
            // - Taking GLP-1: BMI must be >= 20
            if (!isTaking && bmi < 20) {
                // Not taking meds and BMI < 25 = disqualified
                this.addTagForDisqualify();
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Based on your BMI, you don't currently qualify for this treatment."
                    }
                });
                
                return;
            } else if (isTaking && bmi < 20) {
                // Taking meds and BMI < 20 = disqualified
                this.addTagForDisqualify();
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Based on your BMI, you don't currently qualify for this treatment."
                    }
                });
                return;
            }

            // "Are you currently taking a GLP-1" is the only medical question this
            // funnel still asks, so medical_history reports from here rather than
            // from the intake submit two screens earlier.
            this.fireStepEvents(6);

            // Qualified - continue to next step after a brief delay so user sees their selection
            setTimeout(() => {
                if (isTaking) {
                    // Taking GLP-1: go to medication type selection (step 13)
                    this.active_el++;
                } else {
                    // Not taking: clear any previous medication/dosage selections and skip to medication selection (15)
                    this.currentMedicationType = '';
                    this.selectedDosage = '';
                    this.selectedMedication = '';
                    this.active_el += 3;
                }
            }, 300);

        },
        addTagForDisqualify() {
            this.$axios.get(`${this.baseUrl}/forms/add-disqualify`);
        },
        handleCurrentMedicationSelection(medication) {
            // Store the current medication type they're taking
            this.currentMedicationType = medication;
            // Advance to dosage selection (step 14) after a brief delay so user sees their selection
            setTimeout(() => {
                this.active_el++;
            }, 300);
        },

        closeOutOfStockModal() {
            this.showOutOfStockModal = false;
            this.currentMedicationType = ''; // Reset selection
        },

        showOutOfStockForMedication(medication) {
            this.currentMedicationType = medication;
            this.showOutOfStockModal = true;
        },

        advanceStep() {
            // Helper method to advance to next step, skipping commented-out steps
            this.active_el++;
        },

        handleNoneCheckbox() {
            if (this.people.healthConditions.none) {
                // If "None" is checked, uncheck all other conditions
                Object.keys(this.people.healthConditions).forEach(key => {
                    if (key !== 'none') {
                        this.people.healthConditions[key] = false;
                    }
                });
                // Auto-advance to next step after a brief delay
                setTimeout(() => {
                    this.active_el++;
                }, 300);
            }
        },

        handleConditionCheckbox() {
            // If any condition is checked, uncheck "None"
            const anyConditionChecked = Object.keys(this.people.healthConditions).some(key => {
                return key !== 'none' && this.people.healthConditions[key];
            });
            if (anyConditionChecked) {
                this.people.healthConditions.none = false;
            }
        },

        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1900 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },

        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches);
                this.people.heightInInches = heightInInches;
            }
        },

        showError(message) {
            this.errorMessage = message;
            this.showErrorPopup = true;
            setTimeout(() => {
                this.showErrorPopup = false;
            }, 5000);
        },

        isValidName(name) {
            if (!name || name.trim().length < 2) {
                return false;
            }

            const nameRegex = /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\s']+$/;
            return nameRegex.test(name.trim());
        },

        validateFirstName() {
            if (this.people.first_name && this.people.first_name.trim()) {
                if (!this.isValidName(this.people.first_name)) {
                    this.setFieldError('first_name');
                } else {
                    this.clearFieldError('first_name');
                }
            }
        },

        validateLastName() {
            if (this.people.last_name && this.people.last_name.trim()) {
                if (!this.isValidName(this.people.last_name)) {
                    this.setFieldError('last_name');
                } else {
                    this.clearFieldError('last_name');
                }
            }
        },

        validateStep(step) {
            this.formErrors = {};
            this.fieldErrors = {};

            switch (step) {
                case 2:
                    // Step 1 is hero section, no validation needed
                    return true;

                case 3: {
                    // Step 2: State, Sex, DOB form
                    let hasError = false;

                    if (!this.people.state) {
                        this.setFieldError('state');
                        hasError = true;
                    }

                    if (!this.people.gender) {
                        this.setFieldError('gender');
                        hasError = true;
                    }

                    const {
                        mm,
                        dd,
                        yyyy
                    } = this.people.dob;

                    if (!mm) {
                        this.setFieldError('dob_mm');
                        hasError = true;
                    }
                    if (!dd) {
                        this.setFieldError('dob_dd');
                        hasError = true;
                    }
                    if (!yyyy) {
                        this.setFieldError('dob_yyyy');
                        hasError = true;
                    }

                    if (hasError) {
                        this.showError('Please complete all required fields');
                        return false;
                    }

                    if (!this.isValidDate(mm, dd, yyyy)) {
                        this.setFieldError('dob_mm');
                        this.setFieldError('dob_dd');
                        this.setFieldError('dob_yyyy');
                        this.showError('Please enter a valid date of birth');
                        return false;
                    }

                    this.people.dobMMDDYYYY = `${mm}/${dd}/${yyyy}`;
                    break;
                }

                case 4: {
                    const foot = parseInt(this.people.height.foot);
                    const inches = parseInt(this.people.height.inches);
                    const weight = parseFloat(this.people.weight);

                    let heightError = false;
                    let weightError = false;

                    if (isNaN(foot) || foot < 4 || foot > 8) {
                        this.setFieldError('height_foot');
                        heightError = true;
                    }

                    if (isNaN(inches) || inches < 0 || inches > 11) {
                        this.setFieldError('height_inches');
                        heightError = true;
                    }

                    if (isNaN(weight) || weight < 80 || weight > 700) {
                        this.setFieldError('weight');
                        weightError = true;
                    }

                    if (heightError) {
                        this.showError('Please enter a valid height (4-8 feet, 0-11 inches)');
                        return false;
                    }

                    if (weightError) {
                        this.showError('Please enter a valid weight (80-700 pounds)');
                        return false;
                    }

                    this.people.heightInInches = (foot * 12) + inches;
                    this.people.bmi = (weight * 703) / (this.people.heightInInches * this.people.heightInInches);
                    break;
                }

                case 5: {
                    let nameError = false;
                    let errorMessage = '';

                    if (!this.people.first_name || this.people.first_name.trim() === '') {
                        this.setFieldError('first_name');
                        nameError = true;
                        errorMessage = 'Please enter your first name';
                    } else if (!this.isValidName(this.people.first_name)) {
                        this.setFieldError('first_name');
                        nameError = true;
                        if (this.people.first_name.trim().length < 2) {
                            errorMessage = 'First name must be at least 2 characters long';
                        } else {
                            errorMessage = 'First name can only contain letters, spaces, and apostrophes';
                        }
                    }

                    if (!this.people.last_name || this.people.last_name.trim() === '') {
                        this.setFieldError('last_name');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter your last name';
                        } else {
                            errorMessage = 'Please enter valid first and last names';
                        }
                    } else if (!this.isValidName(this.people.last_name)) {
                        this.setFieldError('last_name');
                        nameError = true;
                        if (!errorMessage) {
                            if (this.people.last_name.trim().length < 2) {
                                errorMessage = 'Last name must be at least 2 characters long';
                            } else {
                                errorMessage = 'Last name can only contain letters, spaces, and apostrophes';
                            }
                        } else {
                            errorMessage = 'Names must be at least 2 characters long and contain only letters, spaces, and apostrophes';
                        }
                    }

                    if (!this.isValidEmail) {
                        this.setFieldError('email');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid email address';
                        } else {
                            errorMessage = 'Please complete all fields correctly';
                        }
                    }

                    if (!isValidUsPhone(this.people.phone)) {
                        this.setFieldError('phone');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid US phone number';
                        }
                    }

                    if (nameError) {
                        this.showError(errorMessage);
                        return false;
                    }

                    if (!this.people.agree_to_phone) {
                        this.smsConsentError = 'Please agree to receive SMS communications to continue';
                        this.triggerSmsConsentShake();
                        return false;
                    }

                    
                    break;
                }

            }

            return true;
        },

        triggerSmsConsentShake() {
            this.smsConsentShake = false;
            this.$nextTick(() => {
                this.smsConsentShake = true;
                setTimeout(() => {
                    this.smsConsentShake = false;
                }, 700);
            });
        },

        async handleSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            // Special handling for step 11 - create lead after collecting user details
            if (this.active_el === 5) {
                try {
                    // Age validation
                    if (this.people.dob.yyyy > 2007) {
                        this.$router.push({
                            name: 'leadDisqualified',
                            query: {
                                message: "We cannot proceed since your age is less than 18 years."
                            }
                        });
                        return;
                    }

                    this.people.user_agent = window.navigator.userAgent;
                    
                    // Only the name/email/phone screen's events. Every other screen
                    // reports as the shopper leaves it — see fireStepEvents.
                    this.fireStepEvents(5);

                    // Get session ID for tracking
                    let sessionId = "";
                    try {
                        sessionId = await window.tracking.assertSession();
                    } catch(error) {
                        if (window.trackingSessionId) {
                            sessionId = window.trackingSessionId;
                        }
                    }

                    if (sessionId) {
                        this.people.tracking_session_id = sessionId;
                    }

                    // Normalize to 10 national digits (drops leading 1 country code) before sending
                    const cleanedPhone = cleanUsPhone(this.people.phone);

                    const emailCheckPassed = await this.handleEmailCheck();
                    if (!emailCheckPassed) {
                        return;
                    }

                    this.isSubmitting = true;

                    const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, {
                        ...this.people,
                        phone: cleanedPhone
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            "Access-Control-Allow-Origin": "*"
                        }
                    });

                    if (response.data.status === 'success') {
                        // Fire tracking events for successful form submission
                        try {
                            if (window.tracking) {
                                window.tracking.event('questionnaire_end', { funnel_step: 12, form: "glp1_v2" });
                                window.tracking.event('partial', { 
                                    funnel_step: 13,
                                    event_id: crypto.randomUUID(),
                                    form: "glp1_v2"
                                });
                            }
                        } catch(error) {
                            console.log(error)
                        }
                        
                        this.people.id = response.data.user.id;
                        this.$store.dispatch("doLogin", response.data);
                        // Continue to next step instead of routing away
                        this.active_el++;
                    }
                } catch (error) {
                    console.error('Form submission error:', error);
                    this.showError('There was an error submitting your form. Please try again.');
                } finally {
                    this.isSubmitting = false;
                }
                return;
            }

            if (this.active_el < this.totalSteps) {
                // Report the screen being left before moving off it. This is how the
                // demographics and height/weight screens get their events.
                this.fireStepEvents(this.active_el);
                // Skip step 4 (commented out - category selection)
                this.active_el++;
                return;
            }
        },

        // The guide fires questionnaire_start when the shopper lands on the
        // questionnaire, before any input. It used to wait for the screen 5 submit,
        // so the pixel saw nothing at all until three screens had been filled in.
        async fireQuestionnaireStart() {
            if (!window.tracking || this.active_el !== 3 || this.trackedSteps.includes('start')) return;
            try {
                await window.tracking.assertSession();
                window.tracking.event('questionnaire_start', { funnel_step: 1, form: "glp1_v2" });
                this.trackedSteps.push('start');
                // Persist immediately. Nothing else writes progress until the
                // shopper types, so a refresh before that would start over.
                this.saveProgress();
            } catch (error) {
                console.log(error);
            }
        },

        // One event per question screen, sent as the shopper leaves that screen.
        // Firing the whole set at the screen 5 submit made every screen look
        // instant and erased the drop-off between them, which is the only thing
        // funnel_step measures.
        fireStepEvents(step) {
            if (!window.tracking || this.trackedSteps.includes(step)) return;

            const events = {
                3: [['state', 2], ['sex_at_birth', 2], ['dob_added', 2]],
                4: [['height', 3], ['current_weight', 3]],
                5: [['name_added', 4], ['email_complete', 4], ['phone_added', 4]],
                6: [['medical_history', 5]],
            }[step];
            if (!events) return;

            // BMI is the point of the height/weight screen, so report the confirmation
            // only once a number has actually come out of it.
            if (step === 4 && this.bmi_calculated) events.push(['bmi_confirmation', 3]);

            try {
                events.forEach(([name, funnelStep]) => {
                    window.tracking.event(name, { funnel_step: funnelStep, form: "glp1_v2" });
                });
                this.trackedSteps.push(step);
            } catch (error) {
                console.log(error);
            }
        },

        // Stripe initialization
        async initStripe() {
            stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message;
            this.submitted = false;
        },

        handlePaymentToken(pmToken) {
            this.paymentInfo.cardToken = pmToken;
            this.paymentInfo.paymentMethod = 'card';
            this.submitted = true; // belt-and-suspenders: already set at the pay-button entry before confirmPayment()
            this.processPayment();
        },

        async handleExpressPayment(ev) {
            if (this.submitted) { ev.complete('fail'); return; } // a charge is already in flight
            try {
                this.submitted = true;
                this.correlationId = crypto.randomUUID();
                this.paymentError = false;
                this.paymentInfo.cardToken = ev.tokenId;
                this.paymentInfo.cardDetails = {
                    number: `XXXXXXXXXXXX${ev.card.last4}`,
                    expiration_month: ev.card.exp_month,
                    expiration_year: ev.card.exp_year,
                    cardBin: '',
                    cardBrand: ev.card.brand,
                    cardLast4: ev.card.last4,
                };
                this.paymentInfo.cardLast4 = ev.card.last4;
                this.paymentInfo.cardBrand = ev.card.brand;
                this.paymentInfo.paymentMethod = ev.methodName === 'apple-pay' ? 'apple_pay' : 'google_pay';
                if (ev.payerName && !this.people.first_name) {
                    const nameParts = ev.payerName.split(' ');
                    this.people.first_name = nameParts[0] || '';
                    this.people.last_name = nameParts.slice(1).join(' ') || '';
                }
                if (ev.payerEmail && !this.people.email) {
                    this.people.email = ev.payerEmail;
                }
                await this.processPayment();
                ev.complete('success');
            } catch (error) {
                console.error('[Checkout] Express payment error:', error);
                ev.complete('fail');
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.submitted = false;
            }
        },

        // Pre-fill shipping form from Vuex user/shipping data (only fills empty fields)
        prefillFromUserData() {
            const shipping = this.$store.getters.shipping;
            if (shipping) {
                if (!this.customerInfo.addressLine1 && shipping.address_line_1) this.customerInfo.addressLine1 = shipping.address_line_1;
                if (!this.customerInfo.addressLine2 && shipping.address_line_2) this.customerInfo.addressLine2 = shipping.address_line_2;
                if (!this.customerInfo.city && shipping.city) this.customerInfo.city = shipping.city;
                if (!this.customerInfo.state && shipping.state) this.customerInfo.state = shipping.state;
                if (!this.customerInfo.zip && shipping.zip) this.customerInfo.zip = shipping.zip;
            }
        },

        changePaymentTerms(value) {
            this.paymentInfo.payment_terms = value;
            // Re-report the cart on every term change. Without this add_to_cart only
            // ever described the default term, so a 6-month cart looked like a 12-month one.
            this.fireAddToCart();
        },

        // event_value is displayTotal, the same number the page prints as "Due today",
        // so the event always matches what the shopper is looking at.
        fireAddToCart(product = this.cartItems.find((item) => !item.is_addon) || this.cartItems[0]) {
            const term = Number(this.paymentInfo.payment_terms);
            // Nothing can be reported yet: the cart is still being built or the
            // pixel has not loaded. Leave lastTrackedTerm alone, so the fire that
            // happens once the cart lands is not mistaken for a duplicate. Marking
            // the term here loses the event outright for anyone who picks a plan
            // before the product fetch resolves.
            if (!window.tracking || !product) return;
            if (term === this.lastTrackedTerm) return;

            try {
                window.tracking.event('add_to_cart', {
                    funnel_step: 14,
                    event_value: this.displayTotal,
                    currency: 'USD',
                    product_id: product.id,
                    product_name: product.name,
                    plan_id: product.stripe_id,
                    quantity: 1,
                    form: "glp1_v2"
                });
                this.lastTrackedTerm = term;
            } catch (error) {
                console.log(error);
            }
        },

        continueFromStep17() {
            this.active_el++;
        },

        async selectMedication(medication) {
            // Dose mapping when switching from Semaglutide to Tirzepatide
            const semaToTirzMapping = {
                0.25: 2.5, // S1 -> T1
                0.5: 2.5, // S2 -> T1
                1.0: 5.0, // S3 -> T2
                1.5: 7.5, // S4 -> T3
                2.0: 7.5, // S5 -> T3
                2.5: 10.0 // S6 -> T4
            };

            // If not currently taking any GLP-1, set to lowest dose
            if (!this.currentMedicationType || this.currentMedicationType === '') {
                this.selectedDosage = medication === 'tirzepatide' ? '2.5 mg' : '0.25 mg';
            }
            // Switching from Semaglutide/Ozempic to Tirzepatide
            else if (medication === 'tirzepatide' &&
                (this.currentMedicationType === 'semaglutide' || this.currentMedicationType === 'ozempic') &&
                this.selectedDosage) {

                // Parse the current semaglutide dose
                const currentDose = parseFloat(this.selectedDosage);

                // Map to tirzepatide dose
                if (semaToTirzMapping[currentDose]) {
                    const mappedDose = semaToTirzMapping[currentDose];
                    this.selectedDosage = mappedDose.toFixed(1) + ' mg';
                }
            }
            // Switching from Tirzepatide/Mounjaro to Semaglutide
            else if (medication === 'semaglutide' &&
                (this.currentMedicationType === 'tirzepatide' || this.currentMedicationType === 'mounjaro') &&
                this.selectedDosage) {

                // Always start at lowest Semaglutide dose when switching from Tirzepatide
                this.selectedDosage = '0.25 mg';
            }

            this.selectedMedication = medication;
            await this.createAndSaveCart(medication);
        },

        async createAndSaveCart(medication) {
            this.isLoading = true;

            await this.clearCart();

            // Product IDs for Tirzepatide and Semaglutide (unknown med defaults to sema)
            let productId = this.medProductIds[medication] || this.medProductIds.semaglutide;

            try {
                let product = await getProductsById(productId);
                let plan = product[0];

                const cartItem = {
                    id: plan.id,
                    name: plan.name,
                    category: plan.category.primary,
                    price: plan.pricing.retail_price,
                    retail_price: plan.pricing.retail_price,
                    subheader: 'Compound Medication',
                    sku: plan.sku,
                    stripe_id: plan.stripe_id,
                    quantity: 1,
                    image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                    is_addon: false,
                };

                // add_to_cart fires in saveCart, after loadPlans(). Fired here the only
                // price in reach is the product's one-month retail_price, which is what
                // made this event report 349.97 on a 6-month cart.
                await this.saveCart(cartItem);
            } catch (error) {
                console.error('Error creating cart:', error);
                this.showError('Error adding item to cart. Please try again.');
                this.isLoading = false;
            }
        },

        async saveCart(cartItem) {
            this.isLoading = true;

            let postData = {
                ...cartItem,
                sema_offer: this.$store.getters.offerSema,
                tir_offer: this.$store.getters.offerTir,
            };

            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/save-cart`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data.status === 'success') {
                    this.cartId = response.data.id;
                    this.$store.dispatch('addToCart', cartItem);
                    // Load live plan prices + plan ids while the spinner is still up
                    await this.loadPlans();
                    this.fireAddToCart(cartItem);
                    this.setCartVisibility(false);
                    this.active_el++;
                    this.isLoading = false;
                } else {
                    this.showError('Unexpected response from server');
                    this.isLoading = false;
                }
            } catch (error) {
                console.error('Error saving cart:', error);
                this.showError('Error saving cart. Please try again.');
                this.isLoading = false;
            }
        },

        getMedicationDetails() {
            if (this.selectedMedication === 'tirzepatide') {
                return {
                    name: 'Tirzepatide',
                    subtitle: 'COMPOUNDED W/ B6',
                    image: require('@/assets/images/Tirzepatide-Vial_1.webp'),
                    straightImage: require('@/assets/images/Tirz_straight.webp'),
                    type: 'Subcutaneous Injection',
                    description: 'The most popular, GLP-2 weight loss program that works on two Glucagon receptor.'
                };
            } else {
                return {
                    name: 'Semaglutide',
                    subtitle: 'COMPOUNDED W/ B12',
                    image: require('@/assets/images/Semaglutide-Vial_1.webp'),
                    straightImage: require('@/assets/images/Sema_straight.webp'),
                    type: 'Subcutaneous Injection',
                    description: 'The original, GLP-1 weight loss program that works on one Glucagon receptor.'
                };
            }
        },

        // Fetch the live promo price for BOTH meds up front so the "as low as" hero
        // reflects the API (same source the term cards use) instead of the env fallback.
        // Uses each product's 12-month plan (its lowest per-month); on any miss promoLowest
        // stays null and the hero falls back to pricingConfig.
        async loadLowestPromoPrices() {
            await Promise.all(Object.keys(this.medProductIds).map(async (med) => {
                try {
                    const productId = this.medProductIds[med];
                    const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                        params: { isPromo: true, productId }
                    });
                    if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                        const twelve = response.data.plans.find((plan) => plan && Number(plan.terms) === 12 && plan.price != null);
                        if (twelve) this.promoLowest[med] = Number(twelve.price);
                    }
                } catch (error) {
                    console.error(`Error loading promo price for ${med}:`, error);
                }
            }));
        },
        async loadPlans() {
            try {
                const productId = this.cartItems?.[0]?.id;
                if (!productId) return;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId }
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    this.apiPlans = plans;
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
        },
        getProductPricing() {
            const base = this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
            // Merge live plan prices over the env pricing so missing terms keep the fallback
            const pricing = { monthly: { ...base.monthly }, terms: { ...base.terms } };
            if (this.apiPlans[1]) {
                pricing.monthly = { first: this.apiPlans[1].price, regular: this.apiPlans[1].price };
            }
            [3, 6, 12].forEach((term) => {
                if (this.apiPlans[term]) {
                    pricing.terms[term] = this.apiPlans[term].price;
                }
            });
            return pricing;
        },

        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first;
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },

        getTotalPrice(term) {
            if(term==1){
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            }
            return parseFloat(this.getProductPricing().terms[term].toFixed(2));
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            } else {
                return parseFloat(this.getTotalPrice(this.paymentInfo.payment_terms).toFixed(2));
            }
        },

        getTotalOrderAmount() {
            const basePrice = this.getCurrentPrice();
            const discount = this.paymentInfo.discount || 0;
            return Math.max(0, basePrice - discount);
        },

        formatDollars(n) {
            return Number(Math.floor(n)).toLocaleString('en-US');
        },

        formatPrice(n) {
            return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.showError('Our shipping partners do not deliver to PO Box addresses.');
                return;
            }
            this.customerInfo.addressLine1 = address.street;
            this.customerInfo.addressLine2 = address.address_line2 || '';
            this.customerInfo.city = address.city;
            this.customerInfo.state = address.state;
            this.customerInfo.zip = address.zip;
            this.updateAddress();
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user.id;
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
            }
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        blinkAddress() {
            this.addressBlink = true;
            setTimeout(() => { this.addressBlink = false; }, 1500);
        },
        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.blinkAddress();
                this.submitted = false;
                return false;
            }

            if (this.$refs.stripePayment) {
                await this.$refs.stripePayment.confirmPayment();
            }
        },


        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.blinkAddress();
                this.submitted = false;
                return;
            }

            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.paymentError = true;
                this.errorMessage = 'Our shipping partners do not deliver to PO Box addresses.';
                this.submitted = false;
                return;
            }

            try {
                const billingAddr = this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                // amountInCents already nets out the coupon discount — don't subtract it again.
                const chargeAmount = this.amountInCents;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user.id,
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user.id,
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.people.first_name,
                    lastName: this.people.last_name,
                    email: this.people.email,
                    cartTotal: this.displayTotal,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.orderCartItems,
                    // Stamped onto the PaymentIntent metadata, which fulfillment reads.
                    offer: this.nadOfferSlug,
                    mainProductTotal: this.getTotalOrderAmount(),
                    addonTotal: 0,
                    totalOrderAmount: this.displayTotal,
                    medication: this.selectedMedication || '',
                    drug_mode: this.paymentInfo.drug_mode || '',
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                // The offer params ride along so "Try again" lands back on the same offer.
                const offerParams = new URLSearchParams(offerQuery(this.$route.query)).toString();
                const returnUrl = `${currentUrl}/glp1-v2/klarna-return${offerParams ? `?${offerParams}` : ''}`;

                // Snapshot the cart BEFORE redirecting to Klarna so KlarnaReturn.vue — a fresh
                // page load after the redirect — can send cartItems on /api/confirm-klarna-payment
                // ([{ id: productObjectId, quantity, price }]). Keyed to this payment intent so a
                // stale snapshot never attaches to another checkout that shares KlarnaReturn.vue.
                // Mirrors checkoutCallCenter.vue.
                try {
                    const klarnaMainItem = (this.cartItems || []).find((i) => i && i.is_addon === false) || (this.cartItems || [])[0] || {};
                    const snapshotItems = [{
                        id: klarnaMainItem.id,
                        quantity: 1,
                        price: Number((chargeAmount / 100).toFixed(2)),
                    }];
                    // The offer's free NAD+ line at $0, so the lines still sum to the charge.
                    if (this.offerNadLine) {
                        snapshotItems.push({ id: this.offerNadLine.id, quantity: 1, price: 0 });
                    }
                    sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                        payment_intent_id: clientSecret.split('_secret')[0],
                        items: snapshotItems,
                    }));
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                // Same reason the cart is snapshotted: this page never runs again after
                // the redirect, so it can't fire its own `purchase`. KlarnaReturn.vue
                // fires this once the server confirms the payment.
                stashKlarnaPurchase(clientSecret.split('_secret')[0], {
                    funnel_step: 15,
                    event_value: Number((chargeAmount / 100).toFixed(2)),
                    product_id: this.cartItems?.[0]?.id,
                    product_name: this.cartItems?.[0]?.name,
                    plan_id: this.cartItems?.[0]?.stripe_id,
                    quantity: 1,
                    form: "glp1_v2"
                });

                // Klarna leaves the site, so KlarnaReturn.vue makes the offer instead.
                // Hand it the charge context before the redirect takes this page away.
                this.stashFastTrackOffer(clientSecret.split('_secret')[0], {
                    userId: this.user.id,
                    paymentMethod: 'klarna',
                    paymentTerms: this.paymentInfo.payment_terms,
                    firstName: this.people.first_name,
                    lastName: this.people.last_name,
                    email: this.people.email,
                    shippingAddress,
                    billingAddress: billingAddr,
                    trackingSessionId: window.trackingSessionId || null
                });

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.people.first_name} ${this.people.last_name}`,
                            email: this.people.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async processPayment() {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.medication = this.selectedMedication;
                this.paymentInfo.planId = this.selectedPlanId;

                // Get session ID - same robust pattern as intake-form
                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }


                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.getTotalOrderAmount(),
                    cartTotalNoDiscount: parseFloat((this.getTotalOrderAmount() + (this.paymentInfo.discount || 0)).toFixed(2)),
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    categories: this.people.categories,
                    dosage: this.selectedDosage,
                    cartItems: this.orderCartItems,
                    offer: this.nadOfferSlug,
                    totalOrderAmount: this.getTotalOrderAmount(),
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.people.ip_address || 'unknown',
                    tracking_session_id: sessionId
                };

                // ===== COMMENTED OUT: Original endpoint =====
                // const response = await this.$axios.post(`${this.baseUrl}/api/checkout-newself`, paymentData);
                // ===== END COMMENTED OUT =====
                const response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                // paymentData.amount already nets out the coupon discount — don't subtract it again
                let amountCharged = paymentData.amount / 100;

                if (response.data.status === 'success') {
                    // Save purchased products to localStorage
                    const purchasedItems = this.cartItems.map(item => ({
                        name: item.name,
                        price: amountCharged.toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify(purchasedItems));

                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e);
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Fire purchase tracking event
                    try {
                        if (window.tracking && this.cartItems.length > 0) {
                            window.tracking.event('purchase', {
                                funnel_step: 15,
                                event_id: crypto.randomUUID(),
                                transaction_id: transactionIdentifier,
                                event_value: amountCharged,
                                currency: 'USD',
                                product_id: this.cartItems[0].id,
                                product_name: this.cartItems[0].name,
                                plan_id: this.cartItems[0].stripe_id,
                                quantity: 1,
                                order_id: transactionIdentifier,
                                form: "glp1_v2"
                            });
                        }
                    } catch (error) {
                        console.log('Purchase tracking error:', error);
                    }

                    // Keep submitted = true through the redirect so the overlay
                    // and disabled button persist until upSellPage loads. Resetting
                    // here re-enables the button mid-navigation, opening a
                    // duplicate-charge window.
                    //
                    // Offer priority review on top of the confirmed order, then leave.
                    // With no add-on to offer this hands straight through to pushToRoute.
                    this.offerFastTrackThen({
                        userId: this.user.id,
                        paymentMethod: this.paymentInfo.paymentMethod || 'card',
                        paymentTerms: this.paymentInfo.payment_terms,
                        firstName: this.people.first_name,
                        lastName: this.people.last_name,
                        email: this.people.email,
                        shippingAddress: this.customerInfo,
                        billingAddress: this.customerInfo,
                        trackingSessionId: sessionId
                    }, () => this.pushToRoute(amountCharged, transactionIdentifier));
                } else {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                    this.paymentError = true;
                     this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.payment_terms = 1;//String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                if (this.paymentInfo.paymentMethod) {
                    query.pm = this.paymentInfo.paymentMethod;
                }
                this.$router.push({
                    name: 'upSellPage',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'upSellPage'
                });
            }
        },

        async finalSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            try {
                // Age validation
                if (this.people.dob.yyyy > 2007) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return false;
                }

                this.people.user_agent = window.navigator.userAgent;
                
                // Get session ID with assertSession() as primary source
                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }

                if (sessionId) {
                    this.people.tracking_session_id = sessionId;
                }

                this.isSubmitting = true;

                const submissionData = {
                    ...this.people,
                    phone: cleanUsPhone(this.people.phone) // 10 national digits, drops leading 1 country code
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, submissionData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'choosePlan'
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.showError('There was an error submitting your form. Please try again.');
            } finally {
                this.isSubmitting = false;
            }
        }
    },

    watch: {
        paymentError(val) {
            if (val) {
                clearTimeout(this._errorTimeout);
                this._errorTimeout = setTimeout(() => { this.paymentError = false; }, 10000);
            }
        },
        active_el() {
            // Save progress when step changes
            this.saveProgress();

            // Wait for DOM update, then scroll to question
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.step_forminfo_div, .quizquestiondiv2-copy, .quizquestiondiv2, .question-div-2, .glpquiz_div, .step2_div','step4_div','step5_div','step6_div');
                if (questionDiv) {
                    const header = document.querySelector('.section-fixed-prognav');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20; // Additional padding from header

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'auto'
                    });
                } else {
                    // Fallback to top if no question div found
                    window.scrollTo(0, 0);
                }
            });
        },

        // Auto-save when form data changes
        people: {
            deep: true,
            handler() {
                this.saveProgress();
            }
        },

        selectedMedication() {
            this.saveProgress();
        },

        selectedDosage() {
            this.saveProgress();
        },

        currentMedicationType() {
            this.saveProgress();
        },

        isTakingGLP1() {
            this.saveProgress();
        },

        'people.first_name'() {
            this.clearFieldError('first_name');
        },
        'people.last_name'() {
            this.clearFieldError('last_name');
        },
        'people.email'() {
            this.clearFieldError('email');
        },
        'people.phone'() {
            this.clearFieldError('phone');
        },
        'people.weight'() {
            this.clearFieldError('weight');
        },
        'people.height.foot'() {
            this.clearFieldError('height_foot');
        },
        'people.height.inches'() {
            this.clearFieldError('height_inches');
        },
        'people.state'() {
            this.clearFieldError('state');
        },
        'people.gender'() {
            this.clearFieldError('gender');
        },
        'people.dob.mm'() {
            this.clearFieldError('dob_mm');
        },
        'people.dob.dd'() {
            this.clearFieldError('dob_dd');
        },
        'people.dob.yyyy'() {
            this.clearFieldError('dob_yyyy');
        },
        'paymentInfo.payment_terms'() {
            this.saveProgress();
        },
        'paymentInfo.discount'() {
            this.saveProgress();
        }
    }
}
</script>

<style scoped>

/* Price loading skeleton — hides env fallback price until live promo price loads */
.price-amt {
    display: inline-block;
}
.price-loading {
    color: transparent !important;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    min-width: 3ch;
}
.price-loading::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e9e9e9 25%, #f5f5f5 50%, #e9e9e9 75%);
    background-size: 200% 100%;
    animation: price-shimmer 1.1s ease-in-out infinite;
}
@keyframes price-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Order breakdown under the Due Today bar. Colours are inherited on purpose —
   these checkouts render on both the light and the dark shell. */
.ft-sum-breakdown {
    margin: 14px 0 22px;
}

.ft-sum-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 5px 0;
    font-size: 14px;
    line-height: 1.4;
}

.ft-sum-label {
    opacity: 0.75;
}

.ft-sum-value {
    display: inline-block;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
}

.ft-sum-total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid rgba(128, 128, 128, 0.35);
    font-size: 17px;
}

.ft-sum-total .ft-sum-label {
    opacity: 1;
    font-weight: 700;
}

.ft-sum-total .ft-sum-value {
    font-weight: 700;
}

/* The GLP-1 and free NAD+ product cards. Sizes and colours are the newforms checkout's
   order cards (summer-sale/funnel/screens.jsx and its tokens.css), the same on every
   screen size. The card sets its own white and ink, so it reads on either shell. */
.ft-card {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;
    padding: 12px 14px;
    background: #fff;
    border: 2px solid #e6eef6;
    border-radius: 18px;
}

.ft-card-img {
    flex-shrink: 0;
    width: 42px;
    height: auto;
    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.12));
}

.ft-card-body {
    flex: 1;
    min-width: 0;
}

.ft-card-name {
    font-size: 16px;
    font-weight: 900;
    color: #10243b;
}

.ft-card-sub {
    font-size: 12px;
    font-weight: 700;
    color: #5b6b7d;
}

.ft-card-note {
    margin-top: 4px;
    text-wrap: pretty;
}

.ft-card-price {
    font-size: 18px;
    font-weight: 900;
    color: #205089;
    white-space: nowrap;
}

.ft-card-per {
    font-size: 12px;
    font-weight: 700;
    color: #5b6b7d;
}

.ft-card-free {
    color: #00c042;
}

/* Order Summary lines while the free NAD+ is in: each name with the same picture its
   card shows, the price level with them. */
.order-line-pic {
    align-items: center;
}

.order-line-pic + .order-line-pic {
    margin-top: 10px;
}

.order-line-pic .order-name {
    display: flex;
    align-items: center;
    gap: 12px;
}

.order-line-img {
    flex-shrink: 0;
    width: 42px;
    height: auto;
    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.12));
}

/* The NAD+ cut-out inside the 55px "What's included" box: drawn whole. */
.inclusion-nad-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    object-fit: contain;
}

@media screen and (max-width: 479px) {
    .ft-sum-row {
        font-size: 13px;
    }

    .ft-sum-total {
        font-size: 16px;
    }
}

/* Klarna badge */
.flow-step1-choice {
    position: relative;
}

.klarna-badge-flow {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 60px;
    height: auto;
    border-radius: 4px;
    z-index: 2;
}

/* Plan badges (Popular / Recommended) */
.plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}


/* Plan card spacing/padding — bigger, more uniform */
.checkout_checkbox-field {
    padding: 20px 16px;
    margin-bottom: 14px;
}

.plans-div .checkout_checkbox-field:last-child {
    margin-bottom: 0;
}

/* Ensure the 12-month card has room for the inline savings badge */
.checkout_checkbox-field .div-block-2242 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

/* Mobile: nudge the price + badge box up 4px */
@media screen and (max-width: 991px) {
    .checkout_checkbox-field .div-block-2242 {
        transform: translateY(-4px);
    }
}

.hideOnDesk {
    display: none;
}

.flow-step1-headers {
    margin-bottom: 15px;
}

.flow-inclusions-header {
    margin-bottom: 25px;
    justify-content: center;
    display: flex;
    line-height: 0px;
}

.continue-everything {
    margin-top: 25px;
}

.checkout_checkbox-selected {
    background-color: var(--light-blue);
}

.body_flow.page {
    min-height: 100vh !important;
    height: auto !important;
}

.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.enroll-checkbox-field.field-error {
    border: 2px solid #dc3545;
    border-radius: 4px;
    padding: 8px;
    background-color: rgba(220, 53, 69, 0.05);
}

.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

/* Express Checkout */
.error-popup {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #fee2e2;
    border: 1px solid #ef4444;
    color: #991b1b;
    padding: 12px 24px;
    border-radius: 8px;
    z-index: 2147483647;
    max-width: 90%;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.error-popup-close {
    background: none;
    border: none;
    color: #991b1b;
    font-size: 20px;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1;
    flex-shrink: 0;
}

.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    background: white;
    border: 1px solid #d8dbe0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* NOTE: Uses .pe-divider instead of .divider — webflow CSS defines .divider { width: 1px } which would turn this vertical. */
.pe-divider {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin: 12px 0;
    border: none;
    background: transparent;
}

.pe-divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.pe-divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

/* Klarna Button */
.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

.loading-overlay2 {
    position: fixed;
    inset: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.plan-radio {
    cursor: pointer;
    padding: 15px;
    border: 2px solid #ddd;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
}

.plan-radio.selected {
    border-color: #00c042;
    background-color: #f0fff4;
}

.plan-radio:hover {
    border-color: #00c042;
}

/* Old BT card element style removed — Stripe card elements styled above */

@media screen and (max-width: 991px) {
    .section-fixed-prognav {
        position: relative !important;
        z-index: 99999 !important;
        background-color: white !important;
        /* ADJUST THIS VALUE to change spacing below header (0-50px) */
        margin-bottom: 30px !important;
        padding-bottom: 0 !important;
    }

    .section_checkout-flow {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .flow_wrap {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .glpquiz_div {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .quiz_herodiv {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .error-popup {
        min-width: 90%;
    }
}

@media screen and (max-width: 375px) {

    .quiz_heroviddiv,
    .background-video-10 {
        height: 430px;
    }

    .flex-input-div.dob {
        margin-bottom: 1px;
    }

    .div-block-2251 {
        margin-top: 0px;
    }

    .text-block-1686 {
        font-size: 12px;
    }
}

@media screen and (max-width: 490px) {
    .div-block-2251 {
        margin-top: 5px;
    }

    .flow-inclusions-header {
        font-size: 26px;
    }
}

@media screen and (max-width: 479px) {
    .image-651 {
        width: 16px;
    }

    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }

    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }

    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }

    .klarna-logo {
        height: 16px;
    }
}

@media screen and (max-width: 375px) {
    .flow-inclusions-header[data-v-d0ce333a] {
        margin-top: 15px;
        line-height: 33px;
        font-size: 24px;
    }

    .enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
        font-size: 32px;
    }

    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }

    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 24px;
    }

    .formhero-sub[data-v-71c43630] {
        text-align: left;
        width: 100%;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 5px;
    }

    .product-name-2-copy {
        font-size: 16px;
    }

    .section-fixed-prognav[data-v-d0ce333a] {

        margin-bottom: 5px !important;
    }

    .enroll-checkbox-label.w-form-label {
        font-size: 9px;
    }
}

@media screen and (max-width: 350px) {
    .enroll-header {
        font-size: 30px;
    }

}

.checkout-checkbox-text {
    font-size: 16px;
}

/* Fix dropdown overflow issue on step 18 */
.flow-payment-div {
    overflow: visible !important;
}

.flow_step3-form-div {
    overflow: visible !important;
}

.checkout-form {
    overflow: visible !important;
}

.flow-dropdown-sum {
    overflow: visible !important;
    position: relative;
}

.dropdown-list-18 {
    position: relative !important;
    z-index: 1000;
}

.flow-payment-div.dropdown-expanded {
    padding-bottom: 450px;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;

}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

/* Out of Stock Modal Styles */
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.out-of-stock-modal {
    background-color: #ffffff;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    margin: 0 !important;
    padding: 40px 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: none !important;
}

.out-of-stock-modal .intro-modal-body {
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.out-of-stock-modal .intro-modal-heading {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    margin: 0;
}

.modal-close-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-close-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

span.select-icon {
    position: absolute;
    top: 15px;
    left: 5px;
}

.selectwrap {
    position: relative;
}

.checkout-flow-input.thirds {
    padding-left: 30px;
}

.checkout-flow-dropdown {
    padding-left: 25px;
}

.selectwrap input#birth-month {
    width: 100%;
}

.checkout_checkbox-field:active {
    background-color: #ece6ff00;
    border-color: transparent;
}

.flow_choicesdiv,
.checkout_checkbox-field {
    pointer-events: auto !important;
}

.tosspan {
    position: absolute;
    font-size: 8px;
    bottom: -3px;
    color: gray;
}

/* Hide on mobile (991px is common tablet/mobile breakpoint) */
@media screen and (max-width: 991px) {
    .hide-mobile {
        display: none !important;
    }
}

.email-check-error {
    color: #dc3545;
    font-size: 13px;
    margin-top: 4px;
}
.email-error-highlight {
    border-color: #dc3545 !important;
    background-color: #fff5f5 !important;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    max-width: 450px;
    width: 90%;
    text-align: center;
}
.modal-content h3 {
    margin: 0 0 12px;
    font-size: 20px;
}
.modal-content p {
    margin: 0 0 24px;
    color: #555;
    font-size: 15px;
    line-height: 1.5;
}
.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.modal-btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    border: none;
}
.modal-btn.cancel {
    background: #e9ecef;
    color: #333;
}
.modal-btn.login {
    background: #0c9ac4;
    color: white;
}

.sms-phone-disclaimer {
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
    margin: -8px 0 16px;
}
.sms-phone-disclaimer-link {
    color: inherit;
    text-decoration: underline;
}
@media screen and (max-width: 768px) {
    .sms-phone-disclaimer {
        font-size: 10px;
    }
}
.div-block-2247.phone .enroll-disclaimer-div.form {
    margin-top: 8px;
}
.div-block-2247.phone .enroll-disclaimer-div.form .enroll-checkbox-field.form {
    margin-bottom: 0;
}

/* SMS consent checkbox (beside disclaimer, above Find Your Treatment button) */
.div-block-2247.phone {
    position: relative;
    margin-top: -4px;
}
.sms-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 8px 0 0;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}
.sms-consent-row .sms-phone-disclaimer {
    margin: 0;
    cursor: pointer;
}
.sms-consent-checkbox {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #205089;
    cursor: pointer;
}
.sms-consent-row-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}
.sms-consent-error {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    margin: 0 0 4px;
    color: #dc3545;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
}
.sms-consent-shake {
    animation: smsConsentShake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.sms-consent-shake .sms-consent-checkbox {
    animation: smsConsentPulse 0.6s ease both;
}
@keyframes smsConsentShake {
    10%, 90% { transform: translateX(-1px); }
    20%, 80% { transform: translateX(2px); }
    30%, 50%, 70% { transform: translateX(-4px); }
    40%, 60% { transform: translateX(4px); }
}
@keyframes smsConsentPulse {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.3); }
    60% { transform: scale(0.95); }
}
</style>
